export const sinhalaLanguage = {

    //home page -----------------------------------------------

    //app bar
    home_appBar: "නිවහන",
    aboutUs_appBar: "අප ගැන",
    news_appBar: "පුවත්",
    incidentMap_appBar: "සිදුවීම් සිතියම",
    statistics_appBar: "සංඛ්‍යාලේඛන",
    howTo_appBar: "වෙබ් පිටුව පරිශීලනය කරන්නේ කෙසේද?",
    incidentReport_appBar: "වාර්තා සහ කතා",

    //secure platform
    securePlatform_appBar: "ආරක්ෂිත වාර්තාකරණය",
    securePlatform_badge: "ආරක්ෂිත වේදිකාව",
    securePlatform_title1: "නවතම \"අපේ සල්ලි\" ",
    securePlatform_title2: "ආරක්ෂිත වාර්තාකරණ වේදිකාව",
    securePlatform_description: "ඔබේ අනන්‍යතාව ආරක්ෂා කරගනිමින්, නිර්නාමිකව, TISL වෙත​ කෙළින්ම වාර්තා ඉදිරිපත් කරන්න. ඔබේ අනන්‍යතාව සෑම විටෙකම ආරක්ෂා වේ.",
    securePlatform_chip1: "Anonymous",
    securePlatform_chip2: "Encrypted",
    securePlatform_chip3: "Confidential",
    securePlatform_cta: "Report Grand Corruption",

    //sub menu Report & Stories
    incident_appBar: "වාර්තා",
    story_appBar: "කතා",

    //slide show
    mainTitle_SlideShow: "වෙබ් පිටුව පරිශීලනය කරන්නේ කෙසේද?",
    mainTopTitle_SlideShow: "භාවිතා කරන ආකාරය",
    mainDescription_SlideShow: "වීඩියෝව නරඹා අපේසල්ලි පිළිබඳව සහ පැමිණිල්ලක් සිදුකරන්නේ කෙසෛ්ද යන්න පිළිබඳ වැඩිදුර විස්තර දැනගන්න.",//"Watch Video and Learn More About Apesalli and How to Lodge Complain",

    //button titles
    incidentReportButtonTitle_Story: "ඔබ දකින දේ පවසන්න", //"If You See Something, Say Something",
    incidentReportButtonTitle_Corruption: "වචන මගින් හදවත් මෙහෙයවනු ලබයි, හදවත් මගින් අත්පා මෙහෙයවයි", //"Words Move Hearts, Hearts move Limbs",
    incidentReportButtonTitle_Election: "මැතිවරණ නීති උල්ලංඝණය වීම්", //"Election Violations",

    //button descriptions
    // incidentReportButtonDescription_Story: "Share Your Experience and Views on Bribery and Corruption",
    // incidentReportButtonDescription_Corruption: "Report Incidents of Bribery and Corruption to TISL",
    // incidentReportButtonDescription_Election: "If You See Violations, Report Election Violations to TISL",
    incidentReportButtonDescription_Story: "ට්‍රාන්ස්පේරන්සි ඉන්ටනැෂනල් ශ්‍රී ලංකා ආයතනය වෙත අල්ලස් සහ දූෂණ සිදුවීම් පිළිබඳ පැමිණිලි කරන්න", //"Report Incidents of Bribery and Corruption to TISL",
    incidentReportButtonDescription_Corruption: "අල්ලස් සහ දූෂණ පිළිබඳ ඔබගේ අත්දැකීම් සහ අදහස් හුවමාරු කරගන්න", //"Share Your Experience and Views on Bribery and Corruption",
    incidentReportButtonDescription_Election: "ඔබ මැතිවරණ නීති උල්ලංඝණය කිරීම් දකියි නම් ඒ පිළිබඳ ට්‍රාන්ස්පේරන්සි ඉන්ටනැෂනල් ශ්‍රී ලංකා ආයතනය දැනුවත් කරන්න", //"Report Election Violations to TISL",

    //Read more Button
    readMoreButton: "වැඩිදුර කියවන්න...", //"Read More...",
    viewMoreButton: "වැඩි විස්තර ...", //"View More...",

    //Read more Reports Button
    readMoreReportsButton: "තවත් වාර්තා කියවන්න...", //"Read More Reports...",

    //Read more News Button
    readMoreNewsButton: "වැඩිදුර පුවත් කියවන්න...", //"Read More News...",

    //titles
    incidents_title: "සිදුවීම්",

    //Footer -----------------------------------------------
    footer_addressColomboTitle: "කොළඹ කාර්යාලය", //"Colombo Office",
    footer_addressColomboDescription: "අංක 366, නාවල පාර, නාවල, රාජගිරිය",

    footer_addressPhoneName: "දුරකථන:",
    footer_addressColomboPhoneValue: " (+94) 0114369781 | 0114369782 | 0114369783",

    footer_addressFaxName: "ෆැක්ස්:",
    footer_addressColomboFaxValue: " (+94) 0112865777",

    footer_addressEmailName: "විද්‍යුත් ලිපිනය:",
    footer_addressColomboEmailValue: " tisl@tisrilanka.org",

    footer_addressWebName: "වෙබ් අඩවිය:",
    footer_addressColomboWebValue: "www.tisrilanka.org",
    footer_addressColomboWebHrefValue: "https://www.tisrilanka.org",

    footer_addressMataraTitle: "මාතර කාර්යාලය",
    footer_addressMataraDescription: "17, කාලිදාස පාර, මාතර",

    footer_addressMataraPhoneValue: " (+94) 041 22 33 522",

    footer_addressMataraEmailValue: "alac-matara@tisrilanka.org",

    footer_addressVavuniyaTitle: "වවුනියා කාර්යාලය",
    footer_addressVavuniyaDescription: "SLRC ගොඩනැගිල්ල, ඕෆ් පාක් පාර, වවුනියාව",

    footer_addressVavuniyaPhoneValue: " (+94) 024 222 76 76",
    footer_addressVavuniyaEmailValue: " alac-vavuniya@tisrilanka.org",

    footer_disclaimer_btn: "හිමිකම් අත්හැරීමේ ප්‍රකාශය",
    footer_privacyPolicy_btn: "පෞද්ගලිකත්වය ආරක්ෂා කිරීමේ ප්‍රතිපත්තිය",

    //Disclaimer -----------------------------------------------
    disclaimer_mainTitle: "හිමිකම් අත්හැරීමේ ප්‍රකාශය",
    disclaimer_descriptionP1: "මෙම වෙබ් අඩවියෙහි අන්තර්ගත තොරතුරු පවතින්නේ සාමාන්‍ය තොරතුරු අරමුණු උදෙසා පමණි. තොරතුරු සපයනු ලබන්නේ පොදු මහජනතාව විසින් වන අතර, අප එම තොරතුරු නිරවද්‍ය සහ යාවත්කාලීනව පවත්වාගැනීම සඳහා උත්සාහ දරන නමුත් කිසිදු අරමුණක් වෙනුවෙන් වෙබ් අඩවියෙහි හෝ තොරතුරුවල හෝ එහි අන්තර්ගත ඡායාරූප වල සම්පූර්ණත්වය, සත්‍යතාවය, විශ්වසනීයත්වය, උචිතභාවය හෝ උපයෝජ්‍යතාවය, ප්‍රකාශිත හෝ අනියම් අකාරයෙන් නියෝජනය කිරීමක් හෝ ඒ පිළිබඳ වගවීමක් හෝ අප විසින් දරනු නොලැබේ. ඒ අනුව එම තොරතුරු විශ්වාස කිරීම පිළිබඳ අවදානම පූර්ණ වශයෙන් ඔබ විසින් දැරිය යුතුය.",
    // "The information contained on this website is for general information purposes only. The information is provided by the general public and while we endeavor to keep the information up to date and correct, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability or availability with respect to the website or the information or related graphics contained on the website for any purpose. Any reliance you place on such information is therefore strictly at your own risk.",
    disclaimer_descriptionP2: "මෙම වෙබ් අඩවියෙහි අන්තර්ගත තොරතුරු පළකරන අවස්ථාවේ ඒවායේ නිරවද්‍යභාවය සහතික කිරීම සඳහා ට්‍රාන්ස්පේරන්සි ඉන්ටර්නැෂනල් ශ්‍රී ලංකා ආයතනය විසින් සෑම සාධාරණ උත්සහයක්ම දරන නමුත් ඒවායේ සත්‍යතාවය, විශ්වසනීයත්වය, කාලෝචිතභාවය, හෝ සම්පූර්ණත්වය පිළිබඳ කිසිදු වගකීමක් දරනු නොලබයි. මෙම වෙබ් අඩවිය භාවිතය සම්බන්ධයෙන් පරිශීලකයන් හෝ තුන්වැනි පාර්ශවයන් හෝ විසින් අත්විඳිය හැකි ඍජු හෝ වක්‍රාකාරයේ කිසිදු අලාභයක් සඳහා ට්‍රාන්ස්පේරන්සි ඉන්ටනැෂනල් ශ්‍රී ලංකා වගකීමක් නොදරයි.",
    // "Transparency International Sri Lanka makes all reasonable efforts to ensure that the information presented on this website is accurate at the time it is published, but accepts no liability whatsoever for its correctness, reliability, topicality or completeness. Transparency International Sri Lanka assumes no responsibility for any direct or indirect loss suffered by users or third parties in connection with the use of the website.",
    disclaimer_descriptionP3: "පරිශීලකයන් විසින් ගොනුකරනු ලබන පැමිණිලි/කතා පාදක කොටගෙන ට්‍රාන්ස්පේරන්සි ඉන්ටනැෂනල් ශ්‍රී ලංකා ආයතනය විසින් නීතිමය හෝ වෙනත් සුදුසු ක්‍රියාමාර්ගයන් ගනු ලබන්නේ පැමිණිල්ල පිළිබඳව පූර්ණ වශයෙන් විමර්ශනය කිරීමෙන් පසු සහ යම් ක්‍රියාමාර්ගයක් ගැනීම සඳහා ජීව්‍ය හේතුවක් පවතින බවට සලකන්නේ නම් පමණි. වෙබ් අඩවියට කෙරෙන යොමුකිරීම් පාදක කොටගෙන ක්‍රියාමාර්ග නොගෙන සිටීමේ පූර්ණ අයිතිය ට්‍රාන්ස්පේරන්සි ඉන්ටනැෂනල් ශ්‍රී ලංකා ආයතනය සතුය. කිසිදු පැමිණිල්ලක් සම්බන්ධයෙන් ක්‍රියාමාර්ග ගැනීමට අදාළව රජයේ බලධාරීන්ගේ පාර්ශවයෙන් සිදුවන පමාවීම් පිළිබඳව ට්‍රාන්ස්පේරන්සි ඉන්ටනැෂනල් ශ්‍රී ලංකා ආයතනය කිසිදු වගකීමක් නොගන්නා අතර ඒ සම්බන්ධයෙන් බැඳී නොසිටී.",
    // "Transparency International Sri Lanka will only take legal or other necessary action based on complaints/ stories submitted by users after a thorough follow-up and verification of the complaint, and if it is deemed that there is a viable cause of action. Transparency International Sri Lanka takes no responsibility for, and will not be liable for, not taking any action in relation to submissions made to the website. Transparency International Sri Lanka reserves the right to not take action based on submissions made to the website. Transparency International Sri Lanka takes no responsibility for, and will not be liable for, any delays on the part of government authorities in taking action against any complaint.",
    disclaimer_descriptionP4: "වෙබ් අඩවිය අවහිරතාවයකින් තොරව ක්‍රියාත්මක වීම උදෙසා සියලු පරිශ්‍රමයන් දරනු ලැබේ. කෙසේනමුත්, අපගේ පාලනයෙන් පරිබාහිර වූ තාක්‍ෂණික දෝෂ හේතුවෙන් වෙබ් අඩවිය තාවකාලිකව ක්‍රියාවිරහිත වීම පිළිබඳව ට්‍රාන්ස්පේරන්සි ඉන්ටනැෂනල් ශ්‍රී ලංකා ආයතනය විසින් වගකීමක් නොගන්නා අතර ඒ සම්බන්ධයෙන් බැඳී නොසිටී.",
    // "Every effort is made to keep the website up and running smoothly. However, Transparency International Sri Lanka takes no responsibility for, and will not be liable for, the website being temporarily unavailable due to technical issues beyond our control.",
    disclaimer_descriptionP5: "මෙම වෙබ් අඩවිය හරහා ඔබට ට්‍රාන්ස්පේරන්සි ඉන්ටනැෂනල් ශ්‍රී ලංකා ආයතනයේ පාලනය යටතේ නොපවතින වෙබ් අඩවි සමග සම්බන්ධ වියහැකිය. එම වෙබ් අඩවිවල ස්වභාවය, අන්තර්ගතය සහ ක්‍රියාකාරීත්වය පිළිබඳව අප හට පාලනයක් නොමැත. මෙහි සබැඳීන් අන්තර්ගත වීම මගින් ඒවායෙහි ප්‍රකාශිත අදහස් නිර්දේශ කිරීමක් හෝ අනුමත කිරීමක් අදහස් නොකෙරේ. ට්‍රාන්ස්පේරන්සි ඉන්ටනැෂනල් ශ්‍රී ලංකා යනු රජයේ ආයතනයක් හෝ නීතිය ක්‍රියාත්මක කරන ආයතනයක් හෝ නොවේ.",
    // "Through this website you may be able to link to other websites which are not under the control of Transparency International Sri Lanka. We have no control over the nature, content and availability of those websites. The inclusion of any links does not necessarily imply a recommendation or an endorsement of the views expressed within them. Transparency Sri Lanka is neither a governmental nor law enforcement agency.",

    //FAQ page -----------------------------------------------

    //Title
    faq_mainTitle: "නිතර අසන ප්‍රශ්න",

    //Video Section - body 1
    faq_subTitle: "වෙබ් පිටුව පරිශීලනය කරන්නේ කෙසේද?", //"How to use ApeSalli.lk",
    // faq_description: "Watch Video and Learn More About Apesalli and How to Lodge Complain",

    //body 2
    faq_question1: "1. මෙම වෙබ් අඩවිය හරහා සිදු කරන්නේ කුමක්ද?",
    faq_q1Answer: "Apesalli.lk යනු දූෂණ විරෝධයට අදාළ සියලු දේ පිළබඳව අනාවරණය කිරීම සහ සාකච්ඡා කිරීම උදෙසා සකසන ලද වේදිකාවකි. Apesalli.lk භාවිත කරමින් ඔබට අල්ලස් සහ දූෂණය සම්බන්ධ සිදුවීම් වාර්තා කළහැකි අතර රාජ්‍ය, පෞද්ගලික හෝ සිවිල් සමාජ අංශ තුළ අල්ලස් සහ දූෂණ සම්බන්ධයෙන් ඔබගේ අත්දැකීම් හුවමාරු කරගත හැකිය. මෙය ශ්‍රී ලංංකාවේ දූෂණ විරෝධයට පක්‍ෂව කතිකාවතක් ගොඩනැඟීමට සහ ඒ සම්බන්ධයෙන් ක්‍රියාකාරී වීම උදෙසා වූ වේදිකාවකි.",

    faq_question2: "2. මා මෙය පිළිබඳව උනන්දු විය යුත්තේ ඇයි?",
    faq_q2AnswerPara1: "අල්ලස සහ දූෂණය අප සමාජය තුළ සාමාන්‍යකරණය වී ඇති අතර අප බොහෝ දෙනෙක් ඒ පිළිබඳව සැලකිල්ලක් නොදක්වයි. මෙම විනාශකාරී චක්‍රය බිඳදැමිය හැක්කේ මෙම ගැටලුවට එරෙහිව නැඟීසිටීමෙන් පමණක් වන අතර Apesalli.lk මගින් එය සිදුකිරීම සඳහාම ශ්‍රී ලාංකිකයින්ට අවස්ථාවක් සලසාදෙනු ලබයි.",

    faq_q2AnswerPara2: "සියලුදෙනා කාර්යබහුල දිවිපෙවෙතක් ගතකරනබව ද, පොදු අරමුණක් වෙනුවෙන් පෙනීසිටීම සඳහා වැයකිරීමට තරම් කාලය ඔබට නොමැති බව ද අප දනිමු. මෙම වේදිකාව මගින් අල්ලස සහ දූෂණයට එරෙහිව නැඟීසිටීම සඳහා වූ ක්‍රියාවලිය පහසු කරයි. ඔබ යම් සිදුවීමක් වාර්තා කරනවිට හෝ කතාවක් හුවමාරු කරනවිට එම පණිවුඩය ව්‍යාප්ත කිරීමට මෙම වේදිකාව උපකාරී වන අතර, හැකි අවස්ථාවලදී ඔබ වෙනුවෙන් ඒ පිළිබඳව ක්‍රියාමාර්ග ගැනීමටද යොමුවනු ඇත.",

    faq_question3: "3.	මා යම් සිදුවීමක් පිළිබඳ වාර්තා කළහොත් ඒ පිළිබඳව ගනු ලබන පියවර කවරේද?",
    faq_q3AnswerPart1: "අප විසින්,",
    faq_q3AnswerPart2: "- ලැබුණු පැමිණිලිවලට අදාලව මූලික තේරීමක්  සිදුකෙරේ.",
    faq_q3AnswerPart3: "- වාර්තා වූ සිදුවීමට අදාලව ස්වාධීනව කරුණු තහවුරු කරනු ලබයි.",
    faq_q3AnswerPart4: "- අවශ්‍ය නම් තවත් සාක්‍ෂි එක්රැස් කිරීම සිදුකෙරේ.",
    faq_q3AnswerPart5: "- අදාළ බලධාරීන් වෙත පැමිණිල්ල ගොනුකිරීම සඳහා පැමිණිලිකරුට සහයවීම හෝ ඍජුවම පැමිණිල්ල ගොනුකිරීම සිදුකෙරේ.",

    faq_question4: "4. මා විසින් මගේ අත්දැකීම වෙබ් අඩවියට යොමු කළ විට කළ විට සිදු  වන්නේ කුමක්ද?",
    faq_q4Answer: "අප එම කතාව මිලියන ගණනක් වූ අනෙකුත් ජනතාවට කියවීම, හුවමාරු කිරීම සහ පෙළඹවීමක් ඇතිකිරීම උදෙසා ට්‍රාන්ස්පේරන්සි ඉන්ටනැෂනල් ශ්‍රී ලංකා වෙබ් අඩවියෙහි සහ/හෝ සමාජ මාධ්‍යයන්හි පළකරන්නෙමු. යොමුකරන්නාව දැනුවත් කිරීමෙන් පසු සහ තොරතුරු පවතී නම්, අප විසින් අදාල කතා මත පදනම්ව සුදුසු නීතිමය ක්‍රියාමාර්ග ගනු ඇත.",

    faq_question5: "5. අල්ලස සහ දූෂණය පිළිබඳ මගේ අත්දැකීම හුවමාරු කරගැනීම මගින් ඇතිකළ හැකි වෙනස කුමක්ද?",
    faq_q5Answer: "ඔබගේ කතාව හුවමාරු කරගැනීම තුළින් අන්‍යයන්ටද ඔවුන්ගේ කතා හුවමාරු කරගැනීමට පෙළඹවීමක් සහ දිරිමත්  කිරීමක් සිදුවේ. එසේම, දූෂණයට අදාළ නැඹුරුතා සහ එය බහුලව සිදුවන ස්ථාන සොයාගැනීමට ද අපහට එය උපකාරී වේ.වඩාත්ම වැදගත් කරුණ නම්, ඔබ විසින් බෙදාගන්නා කතාව ඉතා කුඩා සිදුවීමක් ලෙස ඔබ සිතුවද එය දුෂණයට එරෙහිව සටනට ලබා දෙන්නා වූ ඉතා සුවිශාල දායකත්වයකි.",

    faq_question6: "6.	 ඔබ හට වාර්තා කළහැකි දූෂණ වර්ග මොනවාද?", //"6.	 What are the types of corruption you can report?",

    // faq_q6AnswerP1Title: "අල්ලස් - ", //"Bribery"
    // faq_q6AnswerP1Description: "නීතිවිරෝධී, සදාචාර විරෝධී හෝ විශ්වාසය බිඳදමන ක්‍රියාවක් සඳහා පෙළඹවීමක් ලෙස යම් වාසියක් පිරිනැමීම, ලබාදීමට පොරොන්දුවීම, ලබාදීම, ලබාගැනීම හෝ ඉල්ලා සිටීම. ත්‍යාග, ණය, ගාස්තු, දීමනා හෝ වෙනත් වාසි ආකාරයෙන් පෙළඹවීම් සිදුවිය හැකිය (බදු, සේවා, පරිත්‍යාග ආදිය)",
    //  //"The offering, promising, giving, accepting or soliciting of an advantage as an inducement for an action which is illegal, unethical or a breach of trust. Inducements can take the form of gifts, loans, fees, rewards or other advantages (taxes, services, donations, etc.)  The bribe could be in the form of appointment, cash, commission, valuable security, property or interest in property, failure to take action, favor, fee, gift, loan, promise, reward and service.",

    // faq_q6AnswerP2Title: "ලිංගික කප්පම් - ", //"Sexual Favours"
    // faq_q6AnswerP2Description: "මහජන සේවයක් ලබාගැනීම සඳහා රාජ්‍ය නිලධාරියෙකු, අධිකරණ නිලධාරියෙකු, සාමය පිළිබඳ නිලධාරියෙකු හෝ පොලිස් නිලධාරියෙකු වෙත යන පුද්ගලයෙකුට, නීති ප්‍රකාරව ලබාදීමට බැඳී සිටින එම සේවය වෙනුවෙන් ලිංගික අනුග්‍රහයක් ලබාදීමට සිදුවීම (ශ්‍යාමලා ගෝමස්ගේ ලිපිය)",
    // // "When an individual who goes to a public, judicial, peace or police officer for a public service is required to perform a sexual favour in return for the service that they are entitled to by the law.",

    // faq_q6AnswerP3Title: "මහජන මුදල් හෝ දේපළ අවභාවිතය - ", //"Misuse of Public Funds - ",
    // faq_q6AnswerP3Description: "ආයතනයක, සංවිධානයක හෝ සමාගමක තනතුරක් දරන පුද්ගලයෙකු ඔවුන් වෙත භාරකොට ඇති අරමුදල් හෝ භාණ්ඩ, පෞද්ගලික ධනලාභය හෝ වෙනත් කාර්යයන් උදෙසා භාවිත කිරීම හෝ ගනුදෙනු කිරීම (ට්‍රාන්ස්පේරන්සි ඉන්ටනැෂනල් සරල භාෂා මඟපෙන්වීම, මුදල් වංචා කිරීම පිළිබඳ අර්ථය මෙයට ගැලපෙන ලෙස සුළු වශයෙන් සංශෝධනය කරන ලදී)",
    // // "When a person holding office in an institution, organization or company dishonestly and illegally appropriates, uses or traffics the funds and goods they have been entrusted with for personal enrichment or other activities. ",

    // faq_q6AnswerP4Title: "රාජ්‍ය තනතුරු අවභාවිතය - ",//"Misuse of Public Property(Movable/Immovable) -",
    // faq_q6AnswerP4Description: "තමාගේ හෝ අන්‍ය පුද්ගලයෙකුගේ ප්‍රයෝජනය උදෙසා තම ධුරය අනිසි  ආකාරයෙන් භාවිත කරන පුද්ගලයින් (කෙන්යාවේ ආචාරධර්ම සහ දූෂණ-විරෝධී කොමිසමේ අර්ථනිරූපණය)",
    // // "Misuse of any movable or immovable property in every description that are vested in and maintained by the State and used for the purposes of the State. Types of public property are land, buildings, vehicle equipment or other facilities or human resources.",

    // faq_q6AnswerP5Title: "බැඳියා පිළිගැටුම - ", //"Conflict of Interest - ",
    // faq_q6AnswerP5Description: "රාජ්‍ය, ව්‍යාපාරික, මාධ්‍ය ආයතනයකට හෝ සිවිල් සමාජ සංවිධානයකට හෝ ඒවායේ සේවය කරන පුද්ගලයෙකුට තම ධුරයට අදාල රාජකාරි හා ඉල්ලුම් සහ ඔවුන්ගේ පෞද්ගලික අභිලාශ අතරින් තෝරාගැනීමක් කිරීමට සිදුවන අවස්ථා (ට්‍රාන්ස්පේරන්සි ඉන්ටනැෂනල් සරල භාෂා මඟපෙන්වීම)",
    // // "Situation where an individual or the entity for which they work, whether a government, business, media outlet or civil society organization, is confronted with choosing between the duties and demands of their position and their own private interests. The interest could be in the nature of self-dealing, outside employment, family interests and gifts.",

    // faq_q6AnswerP6Title: "රාජ්‍ය ප්‍රසම්පාදන අක්‍රමිකතා - ", //"Public Procurement Irregularities  - ",
    // faq_q6AnswerP6Description: "යම් පුද්ගලයෙක්, සමාගමක් හෝ සංවිධානයක් සඳහා භාණ්ඩ හා සේවා සපයාගැනීම සඳහා, අවශ්‍යතා පිළිබඳ මූලික තක්සේරු කිරීමේ සිට කොන්ත්‍රාත්තුව භාරදීම සහ සේවය ලබාදීම දක්වා සංස්ථාපිත ක්‍රියාපටිපාටීන් සහිත බහු-පියවර ක්‍රියාවලිය තුළ සිදුවන ඕනෑම අක්‍රමිකතාවක්   ",
    // // "Any irregularities in multi-step process of established procedures to acquire goods and services by any individual, company or organization — from the initial needs assessment to the contract’s award and service delivery. The irregularity could be absence of open tendering, collusion, conflict of interest or lack of qualification.",

    // faq_q6AnswerP7Title: "වෙනත් - ", //"Other",
    // faq_q6AnswerP7Description: "වෙනත් ",    // faq_q6AnswerP8Description:"",

    faq_q6AnswerP8Title: "",
    faq_q6AnswerP8Description: "",

    faq_question7: "7. මාගේ පෞද්ගලික තොරතුරු අනාවරණය කිරීමට සිදුවන්නේ ඇයි? ", //"7.	 Why do I have to disclose my personal information?",
    faq_q7Answer: "ඔබගේ පෞද්ගලික තොරතුරු හෙළිදරව් කිරීමට සිදුනොවන අතර වාර්තා සහ කතා වෙබ් අඩවිය ඔස්සේ නිර්නාමිකව පළකළහැකිය. කෙසේවුවද, පෞද්ගලික තොරතුරු හෙළිදරව් කරන්නේ නම්, එය අදාළ සිදුවීම පිළිබඳ විමර්ශනය කිරීමට සහ තොරතුරු එක්රැස් කිරීමටත්, එය පිළිබඳ තවදුරටත් සොයාබැලීම සඳහා ඔබට උපකාර කිරීමටත් අපහට වඩාත් පහසුවක් ඇතිකරයි.",

    //About US page -----------------------------------------------

    //title
    aboutUs_Title: "අප ගැන", //"About Us",

    //description
    aboutUs_description1: "දේශපාලන, රාජ්‍ය, පෞද්ගලික සහ සිවිල් සමාජ ක්‍ෂේත්‍රයන්හි මුල්බැස සහ පැතිරී පවතින දූෂණය ශ්‍රී ලංකාවේ සංවර්ධනය කෙරෙහි අනවරත බාධකයක්ව පවතී. වසර ගණනාවක් පුරා මහජනතාව අතරින් බොහෝදෙනෙක් දූෂණයට එරෙහිව නැඟීසිට හෝ හුදෙක් නිහඬවම එහි බර දරා ඇත. Apesalli.lk නිර්මාණය කරන ලද්දේ මහජනතාවට අල්ලස සහ දූෂණය පිළිබඳ ඔවුන් දන්නා කතා සහ සිදුවීම් වාර්තා කිරීම සහ හුවමාරු කිරීම සඳහා අවස්ථාවක් සලසාදීමේ අරමුණ සහිතවය. මෙම නීතිවිරෝධී ක්‍රියාකාරකම් හෙළිදරවු කිරීම මගින් දූෂණය සහ අල්ලස පිළිබඳව පුළුල් කතිකාවතක් ඇතිකිරීමට, මෙම ගැටලුව පිළිබඳව සමාජයේ ප්‍රචලිතව ඇති මතිමතාන්තර හඳුනාගැනීමට මෙන්ම එබඳු ක්‍රියාවන්ට එරෙහිව නැඟීසිටීමට අදහස් කරන පුද්ගලයින් ඉස්මතු කිරීමටද අරමුණු කරයි. ",

    aboutUs_description2: "ට්‍රාන්ස්පේරන්සි ඉන්ටනැෂනල් ශ්‍රී ලංකා ආයතනයේ දුෂණ මැඩලීමේ කාර්යභාරයයන්හි තවත් එක් අත්‍යවශ්‍ය ක්‍රියාකාරකමක් වශයෙන් Apesalli.lk වෙබ් අඩවිය ක්‍රියාත්මක වේ.",
    aboutUs_description3: "ට්‍රාන්ස්පේරන්සි ඉන්ටනැෂනල් ශ්‍රී ලංකා යනු ට්‍රාන්ස්පේරන්සි ඉන්ටනැෂනල් නමැති දූෂණ විරෝධී ගෝලීය ව්‍යාපාරයේ දේශීය පරිචය වන අතර ශ්‍රී ලංකාව තුළ දූෂණය මුලිනුපුටා දැමීම සහ යහපත් ආණ්ඩුකරණයට අනුබල දීම සඳහා කැපවී ක්‍රියාකරයි. සාධාරණ, සාමකාමී, සහ යුක්තිසහගත වූ අනාගත ශ්‍රී ලංකාවක් ගොඩනැගීම උදෙසා දූෂණය මුලිනුපුටා දැමීම සඳහා වන සාමූහික ප්‍රයත්නයට සහයදීම ට්‍රාන්ස්පේරන්සි ඉන්ටනැෂනල් ශ්‍රී ලංකා ආයතනයේ පරමාර්ථය වේ.",

    //Privacy Policy page -----------------------------------------------

    //title
    privacyPolicy_Title: "පෞද්ගලිකත්වය ආරක්ෂා කිරීමේ ප්‍රතිපත්තිය",

    //Descriptions
    privacyPolicy_Description1: "මෙම වෙබ් අඩවිය ඔබ දන්නා තොරතුරු පළකිරීමට සහ ඔබේ පැමිණිලි ගොනු කිරීමට සඳහා සැකසූ අවකාශයකි. Apesalli.lk හි අප සියලු අදහස් කෙරෙහි විවෘත වන අතර, අප ව්‍යායාමයේ ප්‍රගමනය උදෙසා දායක කරගත හැකි අර්ථවත් අදහස් ඉදිරිපත් කරන මෙන් ඉල්ලා සිටිමු.",

    privacyPolicy_Description2: "තමන් විසින් පළකරන අදහස් පිළිබඳ වගකීම පරිශීලකයන් විසින් දැරිය යුතු අතර, මෙම වෙබ් අඩවියේ පළකෙරෙන කිසිදු කරුණක සත්‍යතාවය හෝ නීත්‍යනුකූලභාවය පිළිබඳ වගකීම වෙබ් අඩවිය විසින් දරනු නොලැබේ. කරුණාකර අසත්‍ය, අපහාසාත්මක, පීඩාකාරී, තර්ජනාත්මක, හානිකර, අශ්ලීල හෝ අසභ්‍ය සිදුවීම් හෝ පුවත් පළ කිරීමෙන් වළකින්න.",
    privacyPolicy_Description3: "මෙම වෙබ් අඩවිය භාවිත කිරීම මගින් පෞද්ගලිකත්වය ආරක්ෂා කිරීමේ අපගේ ප්‍රතිපත්තියෙහි විස්තර කර ඇති ආකාරයට ඔබ මෙම වෙබ් අඩවිය භාවිත කරන ආකාරය පිළිබඳ තොරතුරු එක්රැස් කිරීම සහ භාවිත කිරීම සඳහා අපහට අවසර ලබාදීමට එකඟවේ.",
    privacyPolicy_Description4: " ඔබ Apesalli.lk වෙබ් අඩවිය භාවිත කරන අතරතුර ඔබගේ පුද්ගලික දත්ත සම්බන්ධයෙන් අප විසින් කටයුතු කරන ආකාරය සහ පෞද්ගලිකත්වය ආරක්ෂා කරන ආකාරය මෙම පෞද්ගලිකත්වය ආරක්‍ෂා කිරීමේ ප්‍රතිපත්තිය මගින් පැහැදිලි කෙරේ. පහත විස්තර කෙරෙන ආකාරයට හැර අන් කිසිදු අරමුණක් වෙනුවෙන්, Apesalli.lk වෙබ් අඩවියෙහි හෝ අපගේ වෙනත් ව්‍යාපෘතීන්හි පරමාර්ථ ඉටුකර ගැනීම සඳහා ඔබගේ පුද්ගලික දත්ත එක්රැස්කිරීම, භාවිත කිරීම හෝ හෙළි කිරීම සිදුකරනු නොලැබේ. අපගේ වෙබ් අඩවිය පරිශීලනය කරන්නෙකු වශයෙන් ඔබගේ පෞද්ගලිකත්වය ආරක්‍ෂා කිරීම කෙරෙහි අප කැපවන අතර ඔබගේ තොරතුරුවල පෞද්ගලිකත්වය සහ ආරක්‍ෂාව පිළිබඳව අපි බෙහෙවින් සැලකිලිමත් වන්නෙමු.",

    privacyPolicy_subTitle1: "1. තොරතුරු එක්රැස් කිරීම",
    privacyPolicy_subTitle1Description: "ඔබ වෙබ් අඩවිය වෙත ප්‍රවිශ්ට වීමේදී අප වෙත තොරතුරු දෙවර්ගයක් ලබාදෙනු ලබයි (අ) තනි පුද්ගල මට්ටමින් එක්රැස් කෙරෙන, ඔබ ස්වකැමැත්තෙන්ම අප වෙත ලබාදෙන පෞද්ගලික තොරතුරු සහ (ආ) ඔබ සහ වෙනත් පරිශීලකයන් වෙබ් අඩවිය භාවිත කරන අතරතුර එක්රැස් කෙරෙන සමූහයක් වශයෙන් එම පිරිසගේ වෙබ් අඩවිය භාවිත කිරීමට අදාළ තොරතුරු.",

    privacyPolicy_subTitle1P1: "1.1. පෞද්ගලික තොරතුරු",
    privacyPolicy_subTitle1P1DescriptionP1: "මතු දැක්වෙන පෞද්ගලික තොරතුරු එක්රැස් කෙරෙනු ඇත. නම, ලිපිනය, විද්‍යුත් ලිපිනය, දුරකථන අංකය, වයස, ස්ත්‍රී-පුරුෂභාවය. වාර්තා පළකිරීම, තොරතුරු විමර්ශනය සහ විමසීම් සිදුකිරීම, තොරතුරු හුවමාරුව සහ සන්නිවේදනය, සහ වෙබ් අඩවියෙහි අන්තර් ක්‍රියාකාරීත්ව අංගයන් භාවිත කිරීමට ඔබට අවකාශ පවතී. මෙහිදී ඔබ විසින් වාර්තාවක්/පැමිණිල්ලක් යොමු කිරීමේදී හෝ කතා යොමු කිරීමේදී අවශ්‍ය වන තොරතුරු මෙන්ම ඔබ විසින් ප්‍රකාශයට පත්කිරීමට කැමති පෞද්ගලික තොරතුරු ආදී වශයෙන් ඔබ පිළිබඳ වූ විවිධාකාර තොරතුරු අප විසින් ලබාගැනේ.",
    privacyPolicy_subTitle1P1DescriptionP2: "ඔබගේ පෞද්ගලික තොරතුරු අපවෙත ලබාදීමට එකඟවීම මගින් එම තොරතුරු, පැමිණිලි/සිදුවීම් පිළිබඳ වැඩිදුර විමර්ශනය කිරීම සහ වැඩිදුර තොරතුරු ලබාගැනීම අවශ්‍ය නම් ඔබව සම්බන්ධ කරගැනීම සඳහා භාවිත කිරීමට අදාළ අනුමැතිය ඔබ විසින් ට්‍රාන්ස්පේරන්සි ඉන්ටනැෂනල් ශ්‍රී ලංකා වෙත ලබාදෙනු ලබයි. ඔබ විසින් යොමුකෙරෙන පෞද්ගලික තොරතුරු ඔබගේ විශේෂිත අවසරයකින් තොරව වෙබ් අඩවියෙහි ප්‍රදර්ශනය නොකෙරෙනු ඇත. නීතිමය ක්‍රියාමාර්ගවලට අදාළව හැර වෙනත් හේතු මත පෞද්ගලික තොරතුරු නිශ්චිත අවසරයකින් තොරව නිර්නාමික හෝ තොරතුරු සමූහයක් අකාරයෙන් තුන්වැනි පාර්ශවයන් වෙත ලබානොදෙනු ඇත.",

    privacyPolicy_subTitle1P2: "1.2. ස්ථාන පිළිබඳ තොරතුරු වලට අදාළ භූගෝලීය ඇමුණුම්",
    privacyPolicy_subTitle1P2Description: "ඔබ විසින් අල්ලස් ගැනීම හෝ දූෂිත ක්‍රියාවකට සම්බන්ධ ස්ථානයක් වාර්තා කරනු ලැබූවිට වෙබ් අඩවිය මගින් එම සිද්ධිය සිදුවූ ස්ථානය ආසන්න වශයෙන් නීර්ණය කිරීම සඳහා භූගෝලීය ඇමුණුම් හෝ ස්ථානීය දත්ත භාවිත කරනු ඇත. අල්ලස් ගැනීම හෝ දූෂිත සිදුවීම වාර්තා වූ ස්ථානය වෙබ් අඩවියෙහි ඇති තාප සිතියමෙහි ආසන්න වශයෙන් නිරූපණය කිරීම උදෙසා එම ස්ථානීය දත්ත භාවිත කෙරේ. ට්‍රාන්ස්පේරන්සි ඉන්ටනැෂනල් ශ්‍රී ලංකා මගින් කරුණු සෙවීම, තොරතුරු එක්රැස් කිරීම සහ පැමිණිලිවල සත්‍යාසත්‍යතාව පරීක්‍ෂා කිරීම සඳහා ද එම ස්ථානීය තොරතුරු භාවිත කෙරෙනු ඇත. ඔබ විසින් වාර්තා කරන ලද හෝ යොමුකරන ලද ස්ථානවලට අදාළ තොරතුරු, ඒවා යොමුකළ පුද්ගලයා හඳුනාගත හැකි අවස්ථාවල, ඔබේ ප්‍රකාශිත අනුමැතිය සහ දැනුවත්භාවය මත පමණක් අදාළ බලධාරීන් හෝ වෙනත් තුන්වැනි පාර්ශවයන් වෙත අනාවරණය කෙරෙනු ඇත.",

    privacyPolicy_subTitle1P3: "1.3. වෙබ් අඩවිය භාවිතය පිළිබඳ තොරතුරු",
    privacyPolicy_subTitle1P3DescriptionP1: "වෙනත් වෙබ් අඩවි හා සමානවම මෙම වෙබ් අඩවියද කුකීස් සහ සේවාදායක ලඝු යන සම්මත තාක්‍ෂණික ක්‍රම භාවිත කරමින් ඔබ විසින් මෙම වෙබ් අඩවිය භාවිත කරන ආකාරය පිළිබඳ තොරතුරු එක්රැස් කරයි.  කුකී යනු එයට අනන්‍ය වූ නිර්ණාමික හඳුනාගැනීමේ දත්ත සමූහයක් සහිත ඉතා කුඩා ලේඛනයකි. ඔබ වෙබ් අඩවියක් වෙත පිවිසීමේදී එම වෙබ් අඩවියෙහි පරිගණකය මගින් මෙම ගොනුව ඔබගේ පරිගණක දෘඩාංගයෙහි කුකීස් වෙනුවෙන් විශේෂයෙන් වෙන් වූ කොටසක තැන්පත් කිරීම සඳහා ඔබගේ පරිගණකයෙන් විද්‍යුත් සහ ස්වයංකෘත අවසර ඉල්ලා සිටියි. ඔබගේ අන්තර්ජාල බ්‍රවුසරයේ අභිමතය පරිදි එක් එක් වෙබ් අඩවියට එහි කුකී ඔබගේ බ්‍රවුසරය වෙත යොමුකළ හැකිය.",
    privacyPolicy_subTitle1P3DescriptionP2: "කුකීස් සහ සේවාදායක ලඝු මගින් එක්රැස් කරන තොරතුරු අතරට, වෙබ් අඩවියට පිවිසුනු දිනය සහ වේලාව, බලන ලද වෙබ් පිටු, වෙබ් අඩවියෙහි ගතකළ කාලසීමාව සහ මෙම වෙබ් අඩවියට පිවිසීමට පෙර හා පසු ඔබ පිවිසුනු වෙබ් අඩවි පිළිබඳ තොරතුරු අයත් වේ.",
    privacyPolicy_subTitle1P3DescriptionP3: "ඔබ වෙබ් අඩවිය භාවිත කරන අතරතුර වෙබ් අඩවිය එහි කුකීස් භාවිතයෙන් අනෙකුත් පරිශීලකයන්ගෙන් ඔබ වෙන්කර හඳුනාගනු ලබන අතර ඒ අනුව වෙබ් අඩවිය භාවිත කිරීමට අදාළව ඔබේ අභිමතයන් ඔබට අනන්‍ය වේ. ඔබට අනවශ්‍ය වෙළඳ දැන්වීම් දර්ශනය වීම සහ ආරක්‍ෂාව සඳහා එක් වරකට වඩා වෙබ් අඩවියට ඇතුල්වීමේ අවශ්‍යතාව වැළැක්වීම සඳහාද ඇතැම්විට වෙබ් අඩවිය කුකීස් භාවිත කරයි. කුකීස් සහ සේවාදායක ලඝු ගොනු අපගේ වෙබ් අඩවියට පිවිසෙන්නන් සංඛ්‍යාව සහ පරිශීලකයන් අතර වෙබ් අඩවියෙහි වඩාත් ජනප්‍රිය අංග ගණනය කිරීමට අපහට අවකාශ ලබාදෙයි. වෙබ් අඩවිය සහ අපගේ සේවාවන් නිරන්තරයෙන් වැඩිදියුණු කිරීම පිණිස ප්‍රතිපෝෂණ එක්රැස් කිරීම සඳහා මෙය ආධාරක වේ. කුකීස් මගින් ඔබගේ පෞද්ගලික තොරතුරු එක්රැස් කිරීමට හැකියාවක් නොපවතින අතර, සාමාන්‍යයෙන් ඔබ විසින් සපයනු ලබන කිසිදු පෞද්ගලික තොරතුරක් ඔබගේ කුකීස් තුළ ගබඩා කරනොගැනේ.",
    privacyPolicy_subTitle1P3DescriptionP4: "ඔබගේ පෞද්ගලිකත්වය ආරක්‍ෂා කිරීම සඳහා, ඔබගේ අන්තර්ජාල බ්‍රවුසරය මෙම වෙබ් අඩවිය වෙත අවසර ලබාදෙන්නේ මෙම වෙබ් අඩවියෙන් දැනටමත් එවා ඇති කුකීස් වෙත ප්‍රවිශ්ට වීමට පමණක් බව ද, වෙනත් වෙබ් අඩවි මගින් එවා ඇති කුකීස් වෙත ප්‍රවිශ්ට වීම සඳහා එම අවසරය නොලැබෙන බව ද කාරුණිකව සටහන් කරගන්න.",
    privacyPolicy_subTitle1P3DescriptionP5: "මෙයින් අදහස් කෙරෙන්නේ වෙනත් වෙබ් අඩවිවලින් ඔබ වෙත එවා ඇති කුකීස් වෙත ප්‍රවිශ්ට වීමට අපගේ වෙබ් අඩවියට නොහැකිබවත්, අපගේ වෙබ් අඩවිය මගින් ඔබගේ  පරිගණකය වෙත එවා ඇති කුකීස් හඳුනාගැනීමට හෝ ඒ වෙත ප්‍රවිශ්ට වීමට වෙනත් වෙබ් අඩවිවලට නොහැකිබවත් ය.",

    privacyPolicy_subTitle2: "2. ඔබගේ තොරතුරු තුන්වැනි පාර්ශවයන් සමග හුවමාරු කිරීම",
    privacyPolicy_subTitle2DescriptionP1: "ඔබ විසින් අප වෙත ලබා දී ඇති තොරතුරු, පහත විස්තර කෙරෙන ආකාරයට හැර වෙනත් කිසිදු ආකාරයකට ඔබගේ ප්‍රකාශිත අවසරයකින් තොරව අප විසින් තුන්වැනි පාර්ශවයක් සමග හුවමාරු කරනු නොලැබේ.",
    privacyPolicy_subTitle2DescriptionP2: "මෙම වෙබ් අඩවිය වෙත පැමිණිල්ලක් ලැබුණු පසු, සිදුවූ බවට දැක්වෙන සිද්ධියට අදාළව ගතහැකි ක්‍රියාමාර්ග පිළිබඳව ට්‍රාන්ස්පේරන්සි ඉන්ටනැෂනල් ශ්‍රී ලංකා මගින් විමර්ශනය කරනු ලබයි. එබඳු අවස්ථාවන්හි, ඔබගේ පෞද්ගලික තොරතුරු අපවෙත ලබාදීමට ඔබට සිදුවනු ඇත. ඔබ විසින් අප වෙත යොමු කරන ලද ඉල්ලීම සම්බන්ධයෙන් යම් ක්‍රියාමාර්ගයක් ගැනීමට ප්‍රථම මීට අදාළව ඔබගේ තහවුරු කිරීම අප විසින් ලබාගන්නා බව කාරුණිකව දන්වා සිටිමු. යම් කතාවක් හෝ වාර්තාවක් වෙබ් අඩවිය වෙත යොමුකරනු ලැබූ විට, ට්‍රාන්ස්පේරන්සි ඉන්ටනැෂනල් ශ්‍රී ලංකා මගින් එය සංස්කරණය කොට වෙබ් අඩවියෙහි අන්තර්ගතයක් වශයෙන් පළකරනු ඇත.",
    privacyPolicy_subTitle2DescriptionP3: "ඉහත දැක්වූ ආකාරයට කුකීස් මගින් එක්රැස් කරන ලද තොරතුරු කිසිවක් අප විසින් තුන්වැනි පාර්ශවයන් සමග හුවමාරු කරනු නොලැබේ. අදාළ නීතිරීති යටතේ අනාවරණය කිරීමට සිදුවුවහොත් හෝ, (අ) පවත්නා නීතියට අනුගතවීම හෝ අපවෙත යොමුකරන ලද නෛතික ලේඛනයන් ප්‍රකාරව කටයුතු කිරීම (ආ) අපගේ හිමිකම් සහ දේපළ, වෙබ් අඩවිය සහ/හෝ වෙබ් අඩවි පරිශීලකයන් ආරක්‍ෂා කිරීම (ඇ) මෙම වෙබ් අඩවිය පරිශීලකයන්ගේ ආරක්‍ෂාව, අපගේ ආරක්‍ෂාව හෝ තුන්වැනි පාර්ශවයක ආරක්‍ෂාව සහතික කිරීම අවශ්‍ය යැයි අපහට හැඟීයන්නේ නම් ඔබ මෙම වෙබ් අඩවිය භාවිත කිරීම පිළිබඳ තොරතුරු අනාවරණය කිරීමට සිදුවනු ඇත.",

    privacyPolicy_subTitle3: "3. ඔබගේ දත්ත සඳහා ආරක්ෂාව",
    privacyPolicy_subTitle3Description: "ඔබගේ තොරතුරු අනවසරයෙන් භාවිත කිරීම, අවභාවිතය, වෙනස් කිරීම/දූෂ්‍ය කිරීම වැළැක්වීමට තාක්‍ෂණික වශයෙන් යෙදිය හැකි සියලු පූර්වෝපායයන් සහ ආරක්‍ෂක විධිවිධානයන් යොදමින් ඔබගේ තොරතුරුවල ආරක්‍ෂාව තහවුරු කිරීම සඳහා අප විසින් පියවර ගනු ලැබේ. වෙබ් අඩවිය ආරක්‍ෂිතව පවත්වාගැනීම, දෝෂාවේක්ෂණය, දත්ත විශ්ලේෂණය, පරීක්‍ෂාව, පර්යේෂණ සහ සේවා වැඩිදියුණු කිරීම් උදෙසා අපගේ ප්‍රයත්නයන්හි කොටසක් වශයෙන් ඔබ පිළිබඳව ලැබෙන තොරතුරු අප විසින් භාවිත කෙරෙනු ඇත. කුමන තත්වයක් යටතේ වුවද ඔබගේ පෞද්ගලික තොරතුරු වෙත ප්‍රවේශ වීමේ හැකියාව අපගේ සේවාවන් ක්‍රියාත්මක කිරීම, වර්ධනය කිරීම හෝ වැඩිදියුණු කිරීම සඳහා මෙම තොරතුරු පිළිබඳ දැනුවත් විය යුතු සහ එබඳු තොරතුරු ආරක්‍ෂා කිරීම සඳහා ගිවිසුම් ප්‍රකාරව බැඳී සිටින අපගේ සේවකයින්ට පමණක් සීමා කරන්නෙමු.",

    privacyPolicy_subTitle4: "4. තුන්වැනි පාර්ශවයන්ගේ සබැඳින් ",
    privacyPolicy_subTitle4DescriptionP1: "ට්‍රාන්ස්පේරන්සි ඉන්ටනැෂනල් ශ්‍රී ලංකා මගින් පාලනය නොවන වෙබ් අඩවිවල සබැඳීන් මෙම වෙබ් අඩවියෙහි අන්තර්ගත වියහැකිය. මෙම තුන්වැනි පාර්ශවයන්ගේ සබැඳින් පවතින්නේ ඔබගේ පහසුව උදෙසා වන අතර ඔබ මෙම සබැඳින් භාවිත කරන්නේ නම් එහි අවදානම භාරගැනීමට ඔබ එකඟවේ. Apesalli.lk  වෙබ් අඩවිය හා සබැඳිව ඇති වෙබ් අඩවිවල ක්‍රියාකාරකම් හෝ ඒවායේ අන්තර්ගතය පිළිබඳ Apesalli.lk  අඩවිය හෝ ට්‍රාන්ස්පේරන්සි ඉන්ටනැෂනල් ශ්‍රී ලංකා ආයතනය හෝ වගකීමක් නොදරන බව කාරුණිකව සිහිතබා ගන්නාමෙන් දන්වා සිටිමු.",
    privacyPolicy_subTitle4DescriptionP2: "වෙනත් වෙබ් අඩවි වෙත අධිසබැඳින් බොහෝවිට දක්වා ඇත්තේ මෙම වෙබ් අඩවියෙහි පරිශීලකයන්ට ප්‍රයෝජනවත් වියහැකි මාතෘකා වලට අදාළ තොරතුරු වෙත දක්වනයක් වශයෙන් පමණි. ඔබ සබැඳියක් ඔස්සේ මෙම වෙබ් අඩවියෙහි සිට වෙනත් වෙබ් අඩවියක් වෙත ගමන් කිරීමේදී මෙම පෞද්ගලිකත්වය ආරක්‍ෂා කිරීමේ ප්‍රතිපත්තිය තවදුරටත් ක්‍රියාත්මක නොවන බව කාරුණිකව සිහිතබා ගන්න. වැඩිදුර සබැඳින් සහිත වෙබ් අඩවි ද ඇතුළුව ඔබ විසින් වෙනත් ඕනෑම වෙබ් අඩවියක් තුළ සිදුකරන විමර්ශන සහ අන්තර්ක්‍රියාවන් එම තුන්වැනි පාර්ශවයට අයත් වෙබ් අඩවියේ නීතිරීති සහ ප්‍රතිපත්තිවලට යටත්වන අතර, එබඳු තත්වයන් පිළිබඳ අප විසින් වගකීමක් දරනු නොලැබේ.",


    privacyPolicy_subTitle5: "5. මෙම පෞද්ගලිකත්වය ආරක්‍ෂා කිරීමේ ප්‍රතිපත්තියෙහි වෙනස්කම් සිදුකිරීම",
    privacyPolicy_subTitle5Description1P1: "මෙම පෞද්ගලිකත්වය ආරක්‍ෂා කිරීමේ ප්‍රතිපත්තිය ",
    privacyPolicy_subTitle5Description1P2: "දින සිට ක්‍රියාත්මක වේ. අපගේ පෞද්ගලිකත්වය ආරක්‍ෂා කිරීමේ ප්‍රතිපත්තිය සහ ක්‍රියාපිළිවෙත් වෙනස් කරන අවස්ථාවන්හි, අප විසින් එක්රැස් කෙරෙන්නේ කුමන තොරතුරුද, එම තොරතුරු භාවිත කෙරෙන්නේ කෙසේද සහ ඒවා අනාවරණය කෙරෙන්නේ කුමන තත්වයන් යටතේද යන්න පිළිබඳ ඔබව දැනුවත් කිරීම සඳහා අප විසින් එම වෙනස්කම් වෙබ් අඩවියෙහි පළකෙරෙනු ඇත.",
    privacyPolicy_subTitle5Description2: "කෙසේවුවද, පෞද්ගලිකත්වය ආරක්‍ෂා කිරීමේ ප්‍රතිපත්තියෙහි වෙනස්කම් පූර්ව දැනුම්දීමකින් තොරව ද සිදුවිය හැකි අතර, මෙම වෙබ් අඩවියට පිවිසීම මගින් ඔබ වෙනස් කරන ලද පෞද්ගලිකත්වය ආරක්‍ෂා කිරීමේ ප්‍රතිපත්තයි පිළිබඳ දැනුවත් වී සිටින බවට සහ එයට එකඟත්වය පළකොට ඇතිබවට සලකනු ලැබේ. පවත්නා පෞද්ගලිකත්වය ආරක්‍ෂා කිරීමේ ප්‍රතිපත්තිය පිළිබඳ යාවත්කාලීන වීම සඳහා නිරන්තරයෙන් මෙම වෙබ් අඩවියට පිවිසෙන ලෙස ඔබගෙන් ඉල්ලා සිටිනු ලැබේ.",
    privacyPolicy_subTitle5Description3: "සටහන: වංචනික හෝ අපහාසාත්මක වාර්තා හෝ කතා පළ නොකරන මෙන් කාරුණිකව ඉල්ලා සිටින අතර ඒ සඳහා ඔබට වගකීම භාරගැනීමට සිදුවේ. නීතිය බලාත්මක කරන ආයතනයක් මගින් එබඳු වාර්තාවක් නීතිමය පසුබිමක් යටතේ අභියෝගයට ලක්කළහොත් ඔබගේ අන්තර්ජාල කෙටුම්පත් ලිපිනය එය වෙත ලබාදීමට අපට සිදුවනු ඇත. ඔබ විසින් පළකරන ලද හෝ යොමු කරන ලද යම් අන්තර්ගතයක් නීතිය ඉදිරියේ සාර්ථකව අභියෝගයට ලක්වුවහොත් ඒ පිළිබඳ වගකීම ඔබට භාරගැනීමට සිදු වනු ඇත.",

    //Share Story Form(Page) -----------------------------------------------

    //title
    //"Report Incidents of Bribery and Corruption to TISL",
    shareStory_title: "අල්ලස් සහ දූෂණය සම්බන්ධ සිදුවීම් ට්‍රාන්ස්පේරන්සි ඉන්ටනැෂනල් ශ්‍රී ලංකා වෙත දැනුම්දෙන්න",

    //form
    shareStory_publicAuthorityFieldTitle: "රාජ්‍ය නිලධාරීන් සම්බන්ධ ද?", //"Public Authority Involved?",
    shareStory_publicAuthorityFieldAns1: "ඔව්",
    shareStory_publicAuthorityFieldAns2: "නැත",

    shareStory_authorityNamePlaceholder: "පුද්ගලයාගේ නම සහ තනතුර",
    shareStory_authorityNameTooltip: "කරුණාකර හවුල් වූ පුද්ගලයාගේ නම සහ තනතුර ඇතුළත් කරන්න",

    shareStory_storyAuthorityPlaceholder: "ආයතනය තෝරන්න",
    shareStory_storyAuthorityTooltip: "කරුණාකර ආයතනය තෝරන්න",

    shareStory_storyTitlePlaceholder: "මාතෘකාව",
    shareStory_storyTitleTooltip: "ඔබගේ කතාව සඳහා ඔබම මාතෘකාවක් යෝජනා කරන්න",

    shareStory_dateFieldHelperText: "සිද්ධිය සිදුවූ දිනය",
    shareStory_dateFieldTooltip: "කරුණාකර සිද්ධිය සිදුවූ දිනය තෝරන්න",

    shareStory_districtFieldPlaceholder: "දිස්ත්‍රික්කය",
    shareStory_districtFieldTooltip: "කරුණාකර දිස්ත්‍රික්කයක් තෝරන්න",

    shareStory_storyFieldPlaceholder: "ඔබගේ කතාව",
    shareStory_storyFieldTooltip: "කරුණාකර ඔබගේ කතාව සටහන්කරන්න",

    shareStory_storyFieldWordLimit: "වචන සීමාව", //"Word Limit",

    shareStory_shareInfoFieldTitle: "මාගේ පුද්ගලික තොරතුරු ලබා දීමට කැමතියි",
    shareStory_shareInfoFieldAns1: "ඔව්",
    shareStory_shareInfoFieldAns2: "නැත",

    shareStory_nameField: "නම",
    shareStory_nameFieldTooltip: "කරුණාකර ඔබගේ නම ඇතුලත්කරන්න",

    shareStory_phoneField: "දුරකථන අංකය",
    shareStory_phoneFieldTooltip: "කරුණාකර ඔබගේ දුරකථන අංකය ඇතුලත්කරන්න",

    shareStory_emailField: "විද්‍යුත් ලිපිනය",
    shareStory_emailFieldTooltip: "කරුණාකර ඔබගේ විද්‍යුත් ලිපිනය ඇතුලත්කරන්න",

    //form validation errors
    shareStory_requiredErrorMessageFieldDate: "සිදුවූ දිනය අත්‍යවශ්‍යයි !",
    shareStory_requiredErrorMessageFieldDistrict: "දිස්ත්‍රික්කය අත්‍යවශ්‍යයි!",
    shareStory_requiredErrorMessageFieldStory: "ඔබගේ කතාව අත්‍යවශ්‍යයි!",
    shareStory_requiredErrorMessageFieldName: "නම අත්‍යවශ්‍යයි!",
    shareStory_requiredErrorMessageFieldEmail: "විද්‍යුත් ලිපිනය අත්‍යවශ්‍යයි!",
    shareStory_requiredErrorMessageFieldContactNumber: "දුරකථන අංකය අත්‍යවශ්‍යයි!",

    shareStory_ValidErrorMessageFieldEmail: "කරුණාකරකර වලංගු විද්‍යුත් ලිපිනයක් ඇතුලත්කරන්න!",
    shareStory_contactNumberErrorMessageField: "කරුණාකරකර වලංගු දුරකථන අංකයක් ඇතුලත්කරන්න(උ.දා:0772345678)",

    //dialog boxes
    shareStory_storyFieldDialogMessage: "කරුණාකරකර අල්ලස ඉල්ලීමට හේතුව, නිලධාරියාගේ නම සහ තනතුර, සිද්ධිය සිදුවූ වේලාව ආදී වැඩිදුර විස්තර ඇතුළත් කරන්න.",
    //"Please Enter Further Details Including The Reason For Asking For The Bribe, Name and Designation of The Public Official Involved, Time of The Incident, etc.",
    shareStory_storyFieldDialogButton: "හරි", //"Ok",

    shareStory_noteDialogMessageTitle: "සටහන",//"Note",
    shareStory_noteDialogMessage: "ඔබගේ කතාව සනාථ කිරීම වඩාත් පහසු වනු පිණිස ඔබගේ තොරතුරු අප වෙත ලබා දීමට කටයුතු කරන්න",
    //"We encourage you to provide as much personal information as possible, so we have a better chance of verifying the complaint/story.",

    shareStory_afterShareDialogMessageTitle: "දූෂණයට එරෙහිව නැගීසිටියාට ස්තුතියි !", //"Thank You for Standing Against Corruption !",
    shareStory_afterShareDialogMessageP1: "ඔබගේ යොමු අංකය ", //"Your Reference Number is",
    shareStory_afterShareDialogMessageP2: "ඔබගේ වාර්තාව සාර්ථකව යොමුකරන ලදී", //"Your Report Submitted Successfully!.",
    shareStory_afterShareDialogMessageP3: "ඔබ තවත් ආධාරක ලේඛන හෝ සාක්‍ෂි යොමුකිරීමට අදහස් කරන්නේ නම්, කරුණාකර එම ලේඛනයේ ඉහළ වම් කෙලවරෙහි යොමු අංකය සඳහන්කොට “අංක 366, නාවල පාර, නාවල, රාජගිරිය” යන ලිපිනයට තැපැල් කරන්න.",
    //'*If you wish to submit more supporting documents or evidence, please post them to "අංක 366, නාවල පාර, නාවල, රාජගිරිය" mentioning the reference number on the top left corner of the document. Or Fax the documents anonymously to 0112865777.',
    shareStory_afterShareDialogButton: "හරි",

    //info alert
    shareStory_infoText: "පරිපාලක පරීක්ෂා කිරීමෙන් පසුව කතා සහ අත්දැකීම් පලකරනු ඇත",
    //"Stories will be shared following review by administrator ",

    //button
    shareStory_shareButton: "යොමු කරන්න", //"Share",

    //25 districts
    lng_Districts: [
        { value: "National level", lat: 6.9271, lng: 79.8612, label: "ජාතික මට්ටම" },
        { value: "Ampara", lat: 7.3018, lng: 81.6747, label: "අම්පාර" },
        { value: "Anuradhapura", lat: 8.3114, lng: 80.4037, label: "අනුරාධපුර" },
        { value: "Badulla", lat: 6.9934, lng: 81.0550, label: "බදුල්ල" },
        { value: "Batticaloa", lat: 7.7310, lng: 81.6747, label: "මඩකලපුව" },
        { value: "Colombo", lat: 6.9271, lng: 79.8612, label: "කොළඹ" },
        { value: "Galle", lat: 6.0535, lng: 80.2210, label: "ගාල්ල" },
        { value: "Gampaha", lat: 7.0840, lng: 80.0098, label: "ගම්පහ" },
        { value: "Hambantota", lat: 6.1429, lng: 81.1212, label: "හම්බන්තොට" },
        { value: "Jaffna", lat: 9.6615, lng: 80.0255, label: "යාපනය" },
        { value: "Kalutara", lat: 6.5854, lng: 79.9607, label: "කලුතර" },
        { value: "Kandy", lat: 7.2906, lng: 80.6337, label: "නුවර" },
        { value: "Kegalle", lat: 7.2513, lng: 80.3464, label: "කෑගල්ල" },
        { value: "Kilinochchi", lat: 9.3803, lng: 80.3770, label: "කිලිනොච්චි" },
        { value: "Kurunegala", lat: 7.4818, lng: 80.3609, label: "කුරුනෑගල" },
        { value: "Mannar", lat: 8.9810, lng: 79.9044, label: "මන්නාරම" },
        { value: "Matale", lat: 7.4675, lng: 80.6234, label: "මාතලේ" },
        { value: "Matara", lat: 5.9549, lng: 80.5550, label: "මාතර" },
        { value: "Monaragala", lat: 6.8728, lng: 81.3507, label: "මොණරාගල" },
        { value: "Mullaitivu", lat: 9.2671, lng: 80.8142, label: "මුලතිව්" },
        { value: "Nuwara Eliya", lat: 6.9497, lng: 80.7891, label: "නුවර එලිය" },
        { value: "Polonnaruwa", lat: 7.9403, lng: 81.0188, label: "පොලොන්නරුව" },
        { value: "Puttalam", lat: 8.0408, lng: 79.8394, label: "පුත්තලම" },
        { value: "Ratnapura", lat: 6.7056, lng: 80.3847, label: "රත්නපුර" },
        { value: "Trincomalee", lat: 8.5874, lng: 81.2152, label: "ත්‍රිකුණාමලය" },
        { value: "Vavuniya", lat: 8.7542, lng: 80.4982, label: "වව්නියාව" },
    ],

    //public authorities
    lng_publicAuthorities: [
        {
            label: "රාජ්‍ය ආයතන",
            value: "Public Sector Organizations",
        },
        {
            label: "පෞද්ගලික ආයතන",
            value: "Private Sector Organizations",
        },
        {
            label: "රාජ්‍ය නොවන සංවිධාන",
            value: "Non-government Organizations",
        },
    ],

    //incident types
    lng_incidentTypes: [
        {
            key: 1,
            label: "සිදුවී අවසන්",
            value: "Has Happened",
        },
        {
            key: 2,
            label: "සිදුවෙමින් පවතී",
            value: "Is Happening",
        },
        {
            key: 3,
            label: "ඉදිරියේදී සිදුවනු ඇත",
            value: "Will Happen in the future",
        },
    ],

    //Report Corruption Form(Page) -----------------------------------------------

    //title
    // "Share Your Experience and Views on Bribery and Corruption",
    corruptionReport_title: "අල්ලස් හා දූෂණය පිළිබඳ ඔබගේ අත්දැකීම සහ අදහස සඳහන් කරන්න",

    //stepper Steps
    corruptionReport_stepperSteps:
        [
            "රහසිගතභාවය",
            "වර්ගය තෝරන්න",
            "පොදු තොරතුරු",
            "වර්ගවලට අදාළ තොරතුරු",
        ],

    //Step 1 - form 1
    corruptionReport_ShareDetailsCheckbox1: "මා හට නිර්නාමිකව සිටීමට අවශ්‍ය නැත",
    corruptionReport_ShareDetailsCheckbox2: "මා හට නිර්නාමිකව සිටීමට අවශ්‍යයි",

    corruptionReport_step1NameFieldTooltip: "කරුණාකර ඔබගේ නම ඇතුලත්කරන්න",
    corruptionReport_step1NameFieldPlaceholder: "නම",
    corruptionReport_step1NameFieldErrorMessage: "නම අත්‍යවශ්‍යයි!",
    corruptionReport_step1NameFieldIsString: "කරුණාකරකර වලංගු නමක් ඇතුලත්කරන්න!",
    corruptionReport_step1AgeFieldTooltip: "කරුණාකර ඔබගේ වයස ඇතුලත්කරන්න", //"Please Enter Your Age",
    corruptionReport_step1AgeFieldPlaceholder: "වයස",
    corruptionReport_step1AgeFieldErrorMessage: "වයස අත්‍යවශ්‍යයි!",

    corruptionReport_step1AddressFieldTooltip: "කරුණාකර ඔබගේ ලිපිනය ඇතුලත්කරන්න",
    corruptionReport_step1AddressFieldPlaceholder: "ලිපිනය",
    corruptionReport_step1AddressFieldErrorMessage: "ලිපිනය අත්‍යවශ්‍යයි!",

    corruptionReport_step1ContactNumberFieldTooltip: "කරුණාකර ඔබගේ දුරකථන අංකය ඇතුලත්කරන්න", //"Please Enter Your Contact Number",
    corruptionReport_step1ContactNumberFieldPlaceholder: "දුරකථන අංකය",
    corruptionReport_step1ContactNumberFieldErrorMessage1: "දුරකථන අංකය අත්‍යවශ්‍යයි!", ////"Contact Number is required!",
    corruptionReport_step1ContactNumberFieldErrorMessage2: "කරුණාකරකර වලංගු දුරකථන අංකයක් ඇතුලත්කරන්න(උ.දා:0772345678)", //"Please enter valid Phone Number(Eg:0772345678)",

    corruptionReport_step1EmailFieldTooltip: "කරුණාකරකර විද්‍යුත් ලිපිනය ඇතුලත්කරන්න",
    corruptionReport_step1EmailFieldPlaceholder: "විද්‍යුත් ලිපිනය",
    corruptionReport_step1EmailFieldErrorMessage1: "විද්‍යුත් ලිපිනය අත්‍යවශ්‍යයි!",
    corruptionReport_step1EmailFieldErrorMessage1: "කරුණාකරකර වලංගු විද්‍යුත් ලිපිනයක් ඇතුලත්කරන්න",

    corruptionReport_step1GenderFieldTooltip: "ස්ත්‍රී/පුරුෂභාවය තෝරන්න",

    //genders
    lng_genders: [
        {
            key: "gender_type2",
            label: "පුරුෂ",
            value: "Male",
        },
        {
            key: "gender_type3",
            label: "ස්ත්‍රී",
            value: "Female",
        },
        {
            key: "gender_type4",
            label: "වෙනත්",
            value: "Other",
        },
        {
            key: "gender_type5",
            label: "පැවසිමට අකමැතියි",
            value: "Prefer not to say",
        },
    ],

    //anonymous form
    corruptionReport_step1AnonymousFormGenderFieldTooltip: "ස්ත්‍රී/පුරුෂභාවය තෝරන්න",
    corruptionReport_step1AnonymousFormGenderFieldPlaceholder: "ස්ත්‍රී/පුරුෂභාවය",
    corruptionReport_step1AnonymousFormGenderFieldError: "ස්ත්‍රී/පුරුෂභාවය අත්‍යවශ්‍යයි!",

    //dialogBox
    corruptionReport_nextDialogBoxStep1Title: "ඉදිරියට යෑම සඳහා පහත එක් විකල්පයක් තෝරන්න,",

    corruptionReport_nextDialogBoxSelection: [
        {
            value: "ඔබව සම්බන්ධ කරගන්නා ලෙස අපගේ කාර්යමණ්ඩලයෙන් ඉල්ලන්න",
        },
        {
            value: "ප්‍රශ්නාවලියට පිළිතුරු ලබාදෙන්න",
        }
    ],

    corruptionReport_nextDialogBoxStep1AskToContactTitleP1: "දූෂණයට එරෙහිව නැගීසිටියාට ස්තුතියි !",
    corruptionReport_nextDialogBoxStep1AskToContactTitleP2: "ඔබගේ යොමු අංකය ",
    corruptionReport_nextDialogBoxStep1AskToContactDescriptionP1: "ඔබගේ වාර්තාව සාර්ථකව යොමුකරන ලදී",
    //"Your Report Submitted Successfully!.",
    corruptionReport_nextDialogBoxStep1AskToContactDescriptionP2: "ඔබ තවත් ආධාරක ලේඛන හෝ සාක්‍ෂි යොමුකිරීමට අදහස් කරන්නේ නම්, කරුණාකර එම ලේඛනයේ ඉහළ වම් කෙලවරෙහි යොමු අංකය සඳහන්කොට “අංක 366, නාවල පාර, නාවල, රාජගිරිය” යන ලිපිනයට තැපැල් කරන්න.",
    // 'If you wish to submit more supporting documents or evidence, please post them to "PPP Program Officer, Transparency International Sri Lanka, 5/1, Elibank Road, Colombo 05." mentioning the reference number on the top left corner of the document.',

    corruptionReport_anonymousSwitchDialogBoxTitle: "සටහන", //"Note",
    corruptionReport_anonymousSwitchDialogBoxDescription: "ඔබගේ පැමිණිල්ල සනාථ කිරීම වඩාත් පහසු වනු පිණිස ඔබගේ පෞද්ගලික තොරතුරු අප වෙත ලබා දීමට කටයුතු කරන්න",
    //"We encourage you to provide as much personal information as possible, so we have a better chance of verifying the complaint/story.",


    //button
    corruptionReport_step1NextButton: "ඉදිරියට", //"Next",

    corruptionReport_nextDialogBoxStep1Button1: "ඉදිරියට", //"Next"
    corruptionReport_nextDialogBoxStep1Button2: "අවලංගු කරන්න", //"Cancel"

    corruptionReport_nextDialogBoxStep1AfterAskToContactButton: "හරි", //"OK"

    corruptionReport_step1AnonymousFormNextButton: "ඉදිරියට", //"Next",

    //Step 2 - selection

    //categories
    lng_corruption_types: [

        {
            key: 1,
            label: "අල්ලස්", //"Bribery",
            value: "Bribery",
            desc: "නීතිවිරෝධී, සදාචාර විරෝධී හෝ විශ්වාසය බිඳදමන ක්‍රියාවක් සඳහා පෙළඹවීමක් ලෙස යම් වාසියක් පිරිනැමීම, ලබාදීමට පොරොන්දුවීම, ලබාදීම, ලබාගැනීම හෝ ඉල්ලා සිටීම. ත්‍යාග, ණය, ගාස්තු, දීමනා හෝ වෙනත් වාසි ආකාරයෙන් පෙළඹවීම් සිදුවිය හැකිය (බදු, සේවා, පරිත්‍යාග ආදිය)",
            //"The offering, promising, giving, accepting or soliciting of an advantage as an inducement for an action which is illegal, unethical or a breach of trust. Inducements can take the form of gifts, loans, fees, rewards or other advantages (taxes, services, donations, etc.) (TI plain language guide)",
        },
        {
            key: 2,
            label: "ලිංගික කප්පම්", //"Sexual Favours",
            value: "Sexual Favours",
            desc: "මහජන සේවයක් ලබාගැනීම සඳහා රාජ්‍ය නිලධාරියෙකු, අධිකරණ නිලධාරියෙකු, සාමය පිළිබඳ නිලධාරියෙකු හෝ පොලිස් නිලධාරියෙකු වෙත යන පුද්ගලයෙකුට, නීති ප්‍රකාරව ලබාදීමට බැඳී සිටින එම සේවය වෙනුවෙන් ලිංගික අනුග්‍රහයක් ලබාදීමට සිදුවීම",
            //"when an individual who goes to a public, judicial, peace or police officer for a public service is required to perform a sexual favour in return for the service that they are entitled to by the law (Article by Shyamala Gomez)",
        },
        {
            key: 3,
            label: "මහජන මුදල් හෝ දේපළ අවභාවිතය", //"Misuse of Public Funds or Property",
            value: "Misuse of Public Funds or Property",
            desc: "ආයතනයක, සංවිධානයක හෝ සමාගමක තනතුරක් දරන පුද්ගලයෙකු ඔවුන් වෙත භාරකොට ඇති අරමුදල් හෝ භාණ්ඩ, පෞද්ගලික ධනලාභය හෝ වෙනත් කාර්යයන් උදෙසා භාවිත කිරීම හෝ ගනුදෙනු කිරීම",
            //"When a person holding office in an institution, organisation or company dishonestly and illegally appropriates, uses or traffics the funds and goods they have been entrusted with for personal enrichment or other activities. (TI plain language guide, slightly amended the Embezzlement definition to match this)",

        },
        {
            key: 4,
            label: "රාජ්‍ය තනතුරු අවභාවිතය", //"Misuse of Public Position",
            value: "Misuse of Public Position",
            desc: "තමාගේ හෝ අන්‍ය පුද්ගලයෙකුගේ ප්‍රයෝජනය උදෙසා තම ධුරය අනිසි  ආකාරයෙන් භාවිත කරන පුද්ගලයින්",
            //"A person who uses his office to improperly benefit oneself or another person. (Ethics and Anti-Corruption Commission Kenya definition)"
        },
        {
            key: 5,
            label: "බැඳියා පිළිගැටුම", //"Conflict of Interest",
            value: "Conflict of Interest",
            desc: "රාජ්‍ය, ව්‍යාපාරික, මාධ්‍ය ආයතනයකට හෝ සිවිල් සමාජ සංවිධානයකට හෝ ඒවායේ සේවය කරන පුද්ගලයෙකුට තම ධුරයට අදාල රාජකාරි සහ එයට සම්බන්ධ නියමයන් සහ ඔවුන්ගේ පෞද්ගලික අභිලාශ අතරින් තෝරාගැනීමක් කිරීමට සිදුවන අවස්ථා",
            //"Situation where an individual or the entity for which they work, whether a government, business, media outlet or civil society organization, is confronted with choosing between the duties and demands of their position and their own private interests (TI plain language guide)",
        },
        {
            key: 6,
            label: "රාජ්‍ය ප්‍රසම්පාදන අක්‍රමිකතා", //"Public Procurement Irregularities",
            value: "Public Procurement Irregularities",
            desc: "යම් පුද්ගලයෙක්, සමාගමක් හෝ සංවිධානයක් භාණ්ඩ හා සේවා සපයාගැනීම සඳහා, අවශ්‍යතා පිළිබඳ මූලික තක්සේරු කිරීමේ සිට කොන්ත්‍රාත්තුව භාරදීම සහ සේවය ලබාදීම දක්වා සංස්ථාපිත ක්‍රියාපටිපාටීන් සහිත බහු-පියවර ක්‍රියාවලිය තුළ සිදුවන ඕනෑම අක්‍රමිකතාවක්",
            //"Any irregularities in multi-step process of established procedures to acquire goods and services by any individual, company or organization — from the initial needs assessment to the contract’s award and service delivery (Ethics and Anti-Corruption Commission Kenya definition)"
        },
        {
            key: 7,
            label: "වෙනත්", //"Other",
            value: "Other",
            desc: "වෙනත්", //"other",
        },

    ],

    //button
    corruptionReport_step2Button: "ආපසු", //"Back",

    //Step 3 - Form

    //form
    corruptionReport_step3PublicAuthorityFieldTitle: "රාජ්‍ය නිලධාරීන් සම්බන්ධ ද?", //"Public Authority Involved",
    corruptionReport_step3PublicAuthorityFieldAns1: "ඔව්", //"Yes",
    corruptionReport_step3PublicAuthorityFieldAns2: "නැත", //"No",

    corruptionReport_step3PublicAuthorityNameFieldTooltip: "කරුණාකර සිද්ධියට සම්බන්ධ ආයතනය තෝරන්න",
    //"Please Select Authority Involved",
    corruptionReport_step3PublicAuthorityNameFieldPlaceHolder: "ආයතනය",
    //"Select Authority",
    corruptionReport_step3PublicAuthorityNameFieldRequired: "ආයතනය අත්‍යවශ්‍යයි!",

    corruptionReport_step3PublicAuthorityDesignationFieldTooltip: "කරුණාකර සිද්ධියට සම්බන්ධ පුද්ගලයාගේ නම සහ තනතුර ඇතුලත්කරන්න",
    //"Please Enter Name and Designation of the Person Involved",
    corruptionReport_step3PublicAuthorityDesignationFieldPlaceHolder: "සිද්ධියට සම්බන්ධ පුද්ගලයාගේ නම සහ තනතුර",
    //"Name and Designation of The Person Involved",
    corruptionReport_step3PublicAuthorityDesignationFieldRequired: "සිද්ධියට සම්බන්ධ පුද්ගලයාගේ නම සහ තනතුර අත්‍යවශ්‍යයි!",
    //"Name and Designation field is required!",

    corruptionReport_step3IncidentStatusFieldTooltip: "කරුණාකර වාර්තා වූ සිද්ධිය තෝරන්න", //"Please Select Incident Status",
    corruptionReport_step3IncidentStatusFieldPlaceHolder: "වාර්තා වූ සිද්ධිය", //"Select Incident Status",
    corruptionReport_step3IncidentStatusFieldRequired: "වාර්තා වූ සිද්ධිය අත්‍යවශ්‍යයි!",
    //"Incident Status field is required!",

    corruptionReport_step3DistrictTooltip: "කරුණාකර දිස්ත්‍රික්කය තෝරන්න", //"Please Select District",
    corruptionReport_step3DistrictPlaceHolder: "දිස්ත්‍රික්කය",
    corruptionReport_step3DistrictRequired: "දිස්ත්‍රික්කය අත්‍යවශ්‍යයි!",

    corruptionReport_step3DivisionalSecretariatsTooltip: "කරුණාකර ප්‍රාදේශිය ලේකම් කොට්ඨාශය තෝරන්න",
    //"Please Select Divisional Secretariat",
    corruptionReport_step3DivisionalSecretariatsPlaceHolder: "ප්‍රාදේශිය ලේකම් කොට්ඨාශය",
    //"Select Divisional Secretariat",
    corruptionReport_step3DivisionalSecretariatsRequired: "ප්‍රාදේශිය ලේකම් කොට්ඨාශය අත්‍යවශ්‍යයි!",
    //"Divisional Secretariat field is required!",

    corruptionReport_step3DateTooltip: "කරුණාකර වාර්තා වූ සිද්ධිය සිදුවූ දිනය තෝරන්න", //"Please Select Date of Incident",
    corruptionReport_step3DatePlaceHolder: "වාර්තා වූ සිද්ධිය සිදුවූ දිනය",
    corruptionReport_step3DateRequired: "වාර්තා වූ සිද්ධිය සිදුවූ දිනය අත්‍යවශ්‍යයි!", //"Date field is required!",

    corruptionReport_step3TimeTooltip: "කරුණාකර වාර්තා වූ සිද්ධිය සිදුවූ වේලාව තෝරන්න", //"Please Select Time of Incident",
    corruptionReport_step3TimePlaceHolder: "වාර්තා වූ සිද්ධිය සිදුවූ වේලාව",
    corruptionReport_step3TimeRequired: "වාර්තා වූ සිද්ධිය සිදුවූ වේලාව අත්‍යවශ්‍යයි!", //"Time field is required!",

    corruptionReport_step3MapTitle: "ස්වයංක්‍රීයව තෝරා ගත් ස්ථානය වැරදි නම් හෝ සිද්ධිය සිදු වූ ස්ථානය නිශ්චිතවම ඔබ දන්නේ නම් කරුණාකර පහත සිතියමේ එය තෝරන්න ",
    //"If the automatically selected location is incorrect or if you know the exact location of the incident, please select it on the map below.",

    //buttons
    corruptionReport_step3BackButton: "ආපසු",
    corruptionReport_step3NextButton: "ඉදිරියට",

    //step 4 - form

    //bribery from & sexual favor form common
    corruptionReport_step4_Bribery_field1Title: "සිදුවීමට අදාළ පුද්ගලයා", //"Is the person you are reporting a*:",

    //person types
    lng_ReportingPersonTypes: [
        {
            key: 1,
            label: 'නියෝජිතයෙක්',
            value: 'Agent',
        },
        {
            key: 2,
            label: 'ලබාදෙන්නා',
            value: 'Giver',
        },
        {
            key: 3,
            label: 'ලබාගන්නා',
            value: 'Recipient',
        },
        {
            key: 4,
            label: 'නොදනී',
            value: 'Unknown',
        },
    ],

    //bribe typeS
    lng_Corruption_Bribe_Types: [

        { key: 1, label: "රැකියාවක්", value: "Appointment" },
        { key: 2, label: "මුදල්", value: "Cash" },
        { key: 3, label: "සුරැකුම්/දේපළ හෝ දේපළ පිලිබඳ සැලකිල්ලක්", value: "Property or interest in property" },
        { key: 4, label: "කොමිස්", value: "Commission" },
        { key: 5, label: "සුරැකුම්", value: "Valuable Security" },
        { key: 6, label: "ක්‍රියාමාර්ග නොගැනීම", value: "Failure to take action" },
        { key: 7, label: "උදව්", value: "Favor" },
        { key: 8, label: "ගාස්තු", value: "Fee" },
        { key: 9, label: "ත්‍යාග", value: "Gift" },
        { key: 10, label: "ණය", value: "Loan" },
        { key: 11, label: "පොරොන්දු", value: "Promise" },
        { key: 12, label: "දීමනාවක්", value: "Reward" },
        { key: 13, label: "සේවයක්", value: "Service" },

    ],

    //bribe type form field
    corruptionReport_step4_Bribery_field2Title: "සම්බන්ධවන ආකාරය තෝරන්න", //"Please Select Bribe Type",
    corruptionReport_step4_Bribery_field2Placeholder: " අල්ලසෙහි ස්වභාවය සඳහන් කරන්න ", //"In what form was the bribe",
    corruptionReport_step4_Bribery_field2Error: "සම්බන්ධවන ආකාරය අත්‍යවශ්‍යයි!", //"Bribe Type is required",

    //monetary value form field
    corruptionReport_step4_Bribery_field3Title: "කරුණාකර මූල්‍යමය අගය ඇතුලත්කරන්න", //"Please Enter the amount",
    corruptionReport_step4_Bribery_field3Placeholder: " මූල්‍යමය අගය", //"Monetary Value",

    //misused properties
    corruptionReport_step4_MisuseProperty_fieldTitle: "දේපළ වර්ගය තෝරන්න", //"Please Select Type of The Property",
    corruptionReport_step4_MisuseProperty_fieldPlaceholder: "දේපළ වර්ගය", //Select Type of The Property",
    corruptionReport_step4_MisuseProperty_fieldError: "දේපළ වර්ගය අත්‍යවශ්‍යයි!", //"Type of Property is required",

    lng_misused_PropertyTypes: [
        { key: 1, label: "මුදල්", value: "Money" },
        { key: 2, label: "ඉඩම්", value: "Land" },
        { key: 3, label: "ගොඩනැගිලි", value: "Buildings" },
        { key: 4, label: "වාහන", value: "Vehicle" },
        { key: 5, label: "උපකරණ", value: "Equipment" },
        { key: 6, label: "රාජ්‍ය නිලධාරීන්/මානව සම්පත්", value: "Public officials/Human resources" },
        { key: 7, label: "වෙනත්", value: "Other" },
    ],

    //misused position
    corruptionReport_step4_MisusePosition_fieldTitle: "චූදිතයා ලබාගෙන හෝ ලබාදී ඇත්තේ කුමන ප්‍රතිලාභයක්ද? ",
    // "What benefit has the culprit obtained or given out?",
    corruptionReport_step4_MisusePosition_fieldPlaceholder: "ලබාගෙන හෝ ලබාදී ඇත්තේ කුමන ප්‍රතිලාභයක්ද?",
    //"What benefit has the culprit obtained?",
    corruptionReport_step4_MisusePosition_fieldError: "චූදිතයා ලබාගෙන හෝ ලබාදී ඇත්තේ කුමන ප්‍රතිලාභයක්ද? යන්න අත්‍යාවශ්‍යයි!",
    //"Benefit is required",

    //conflict of interest types
    lng_conflictOFInterest_AnswerTypes: [
        {
            key: "type1",
            label: "ඔව්",
            value: "Yes",
        },
        {
            key: "type2",
            label: "නැත",
            value: "No",
        },
        {
            key: "type3",
            label: "නොදනී",
            value: "Unknown",
        }
    ],

    //conflict of interest form fields
    corruptionReport_step4_ConflictOFInterest_field1Title: "අදාළ පුද්ගලයාට පෞද්ගලික බැඳියාවන් පවතීද?",
    //"Does the person have a private interest?",
    corruptionReport_step4_ConflictOFInterest_field2Title: "එම පුද්ගලයා තම බැඳියාවන් හෙලිදරව් කළේද?",
    //"Did the person disclose his or her interest?",
    corruptionReport_step4_ConflictOFInterest_field3Title: "ඔහුගේ හෝ ඇයගේ පෞද්ගලික බැඳියාවන් සම්බන්ධ වූ තීරණයක් ගැනීමට ඔහු හෝ ඇය සහභාගි වූයේද?",
    //"Did he or she participate in the making of a decision that involved his or her private interest?",
    corruptionReport_step4_ConflictOFInterest_field4Title: "එම තීරණය ගැනීමට අදාළ ක්‍රියාවලියට සම්බන්ධ වීමට එම පුද්ගලයාට බලය ලැබී තිබුණිද?",
    //"Was the person authorized to participate in the process of making that decision?",

    corruptionReport_step4_ConflictOFInterest_field5Title: "බැඳියාවේ ස්වභාවය කුමක්ද?",
    //"Please Select Nature of Interest",
    corruptionReport_step4_ConflictOFInterest_field5PlaceHolder: "බැඳියාවේ ස්වභාවය",
    //"Select Nature of Interest",

    lng_conflictOFInterest_NatureOfInterestTypes: [
        { key: 1, label: "ස්වයං ගනුදෙනු", value: "Self-Dealing" },
        { key: 2, label: "බාහිර රැකියාවක්", value: "Outside Employment" },
        { key: 3, label: "පවුල හා සම්බන්ද බැඳියාවන්", value: "Family Interests" },
        { key: 4, label: "ත්‍යාග", value: "Gifts" },
        { key: 5, label: "නොදනී", value: "Unknown" },
    ],

    //procurement form fields
    corruptionReport_step4_Procurement_fieldTitle: "ඔබ වාර්තා කරන්නේ කුමන වර්ගයේ රාජ්‍ය ප්‍රසම්පාදන අක්‍රමිකතාවක්ද? ",
    //"What type of public procurement irregularity?",
    corruptionReport_step4_Procurement_fieldPlaceholder: "රාජ්‍ය ප්‍රසම්පාදන අක්‍රමිකතාව",
    //"Type of the public procurement irregularity",

    lng_procurementTypes: [
        { key: 1, label: "විවෘත ටෙන්ඩර් කැඳවීමක් නොමැතිවීම", value: "Absence of open tendering" },
        { key: 2, label: "වංචාවට හවුල්වීම", value: "Collusion" },
        { key: 3, label: "බැඳියා පිළිගැටුම", value: "Conflict of Interest" },
        { key: 4, label: "සුදුසුකම් නොමැතිවීම", value: "Lack of qualification" },
        { key: 5, label: "නොදනී", value: "Unknown" },
    ],

    //other details form filed
    corruptionReport_step4_Other_fieldTitle: "වෙනත් විස්තර ඇතුලත්කරන්න",//"More Details",
    corruptionReport_step4_Other_fieldPlaceholder: "වෙනත් විස්තර",//"Any Other Details",
    corruptionReport_step4_Other_fieldError: "වෙනත් විස්තර අත්‍යවශ්‍යයි!", //"Description is required",

    //button
    corruptionReport_step4BackButton: "ආපසු", //"Back",
    corruptionReport_step4FinishButton: "ඉදිරියට", //"Finish",

    //file upload
    corruptionReport_step4UploadButton: "පින්තූර සාක්‍ෂි/ඇමුණුම්", //"Upload Images",
    corruptionReport_step4UploadButtonVideo: "විඩියෝ සාක්‍ෂි/ඇමුණුම්", //"Upload Videos",
    corruptionReport_step4TrashIconTooltip: "ඉවත්කරන්න", //"Remove",
    corruptionReport_step4UploadButtonText: "සාක්‍ෂි/ඇමුණුම් සංඛාව:", //"Files Chosen:",

    //instructions
    corruptionReport_step4InstructionsTitle: "සටහන", //"Please Read Before Submit",
    corruptionReport_step4InstructionsDescription: "ඔබගේ නිර්නාමිකබව අනතුරේ හෙලන තොරතුරු දත්ත ගොනු තුළ අන්තර්ගත වියහැකිය. ඔබ නිර්නාමිකව සිටීමට අදහස් කරන්නේ නම් ගොනුව උඩුගත කිරීමට පෙර එබඳු තොරතුරු සියල්ල ඉවත් කරන්න. ඔබ එබඳු තොරතුරු ඉවත් කිරීමට අපොහොසත් නම්, කරුණාකර ලේඛනයේ මුද්‍රිත පිටපතක් “අංක 366, නාවල පාර, නාවල, රාජගිරිය” යන ලිපිනයට නිර්නාමිකව යොමුකරන්න. වාර්තා කිරීමේ ක්‍රියාවලියෙහි අග දක්වා ඇති යොමු අංකය එහි සඳහන් කරන්න.ඔබ වැඩිදුර තොරතුරු, ලේඛන හෝ සාක්‍ෂි යොමුකිරීමට අදහස් කරන්නේ නම්, කරුණාකර එම ලේඛනයේ ඉහළ වම් කෙලවරෙහි යොමු අංකය සඳහන්කොට “අංක 366, නාවල පාර, නාවල, රාජගිරිය” යන ලිපිනයට තැපැල් කරන්න.",
    // 'Files may contain hidden personal information that could jeopardize your anonymity. If you wish to remain anonymous, please remove all such information before uploading a file. If you are unable to remove such information, please send a printed copy of the document anonymously to "PPP Program Officer, Transparency International Sri Lanka, 5/1, Elibank Road, Colombo 05". Please mention the reference number that is provided at the end of the reporting process.',

    //Dialog box step 4
    corruptionReport_step4DialogBoxTitleP1: "දූෂණයට එරෙහිව නැගීසිටියාට ස්තුතියි !", //"Thank You for Standing Against Corruption !",
    corruptionReport_step4DialogBoxTitleP2: "ඔබගේ යොමු අංකය ", //"Your Reference Number is ",

    corruptionReport_step4DialogBoxDescriptionP1: "ඔබගේ වාර්තාව සාර්ථකව යොමුකරන ලදී", //"Your Report Submitted Successfully!.",
    corruptionReport_step4DialogBoxDescriptionP2: "ඔබ තවත් ආධාරක ලේඛන හෝ සාක්‍ෂි යොමුකිරීමට අදහස් කරන්නේ නම්, කරුණාකර එම ලේඛනයේ ඉහළ වම් කෙලවරෙහි යොමු අංකය සඳහන්කොට “අංක 366, නාවල පාර, නාවල, රාජගිරිය” යන ලිපිනයට තැපැල් කරන්න.", //'If you wish to submit more supporting documents or evidence, please post them to "PPP Program Officer, Transparency International Sri Lanka, 5/1, Elibank Road, Colombo 05." mentioning the reference number on the top left corner of the document.',
    corruptionReport_step4DialogBoxDescriptionP3: "කරුණාකර රැඳීසිටින්න, ඈඳුම පරිගණකගත වෙමින් පවතී...", //"Please wait. Uploading Attachments...",
    corruptionReport_step4DialogBoxDescriptionP4: "ඈඳුම් සාර්ථකව පරිගණකගත විය", //"Attachments upload successful!",

    corruptionReport_step4DialogBoxButton: "හරි", //"Ok",

    //Report Election Form(Page) -----------------------------------------------

    //title
    electionReport_title: "මැතිවරණ නීති උල්ලංඝනය කිරීම", //"Report Election Violations",

    //stepper steps
    electionReport_stepperSteps:
        [
            "පෞද්ගලික තොරතුරු",
            "පොදු තොරතුරු",
            "යොමුකරන්න",
        ],

    //stepper step 1 - form
    electionReport_step1_nameFieldTitle: "කරුණාකර ඔබගේ නම ඇතුලත්කරන්න", //"Please Enter Your Name",
    electionReport_step1_nameFieldPlaceholder: "නම",
    electionReport_step1_nameFieldError: "නම අත්‍යවශ්‍යයි!",

    electionReport_step1_ageFieldTitle: "කරුණාකර ඔබගේ වයස ඇතුලත්කරන්න", //"Please Select Your Age",
    electionReport_step1_ageFieldPlaceholder: "වයස",
    electionReport_step1_ageFieldError: "වයස අත්‍යවශ්‍යයි!",

    electionReport_step1_addressFieldTitle: "කරුණාකර ඔබගේ ලිපිනය ඇතුලත්කරන්න", //"Please Enter Your Address",
    electionReport_step1_addressFieldPlaceholder: "ලිපිනය",
    electionReport_step1_addressFieldError: "ලිපිනය අත්‍යවශ්‍යයි",

    electionReport_step1_contactNumberFieldTitle: "කරුණාකර ඔබගේ දුරකථන අංකය ඇතුලත්කරන්න", //"Please Enter Your Contact Number",
    electionReport_step1_contactNumberFieldPlaceholder: "දුරකථන අංකය",
    electionReport_step1_contactNumberFieldError1: "දුරකථන අංකය අත්‍යවශ්‍යයි!",
    electionReport_step1_contactNumberFieldError2: "කරුණාකරකර වලංගු දුරකථන අංකයක් ඇතුලත්කරන්න(උ.දා:0772345678)",

    electionReport_step1_emailFieldTitle: "කරුණාකරකර විද්‍යුත් ලිපිනය ඇතුලත්කරන්න", //"Please Enter Your Email",
    electionReport_step1_emailFieldPlaceholder: "විද්‍යුත් ලිපිනය",
    electionReport_step1_emailFieldError1: "විද්‍යුත් ලිපිනය අත්‍යවශ්‍යයි!",
    electionReport_step1_emailFieldError2: "කරුණාකරකර වලංගු විද්‍යුත් ලිපිනයක් ඇතුලත්කරන්න",

    electionReport_step1_genderFieldTitle: "ස්ත්‍රී/පුරුෂභාවය තෝරන්න",

    //buttons
    electionReport_step1_NextButton: "ඉදිරියට",

    //stepper step 2 - form
    electionReport_step2_publicAuthorityInvolvedFieldTitle: "රාජ්‍ය නිලධාරීන් සම්බන්ධ ද?", //"Public authority involved?",
    electionReport_step2_publicAuthorityInvolvedFieldAns1: "ඔව්", //"Yes",
    electionReport_step2_publicAuthorityInvolvedFieldAns2: "නැත", //"No",

    electionReport_step2_publicAuthorityFieldTitle: "කරුණාකර සිද්ධියට සම්බන්ධ ආයතනය තෝරන්න",
    //"Please Select Authority Involved",
    electionReport_step2_publicAuthorityFieldPlaceholder: "ආයතනය", //"Select Authority",
    electionReport_step2_publicAuthorityFieldError: "ආයතනය අත්‍යවශ්‍යයි!", //"Authority field is required!",

    electionReport_step2_publicAuthorityDesignationFieldTitle: "කරුණාකර සිද්ධියට සම්බන්ධ පුද්ගලයාගේ නම සහ තනතුර ඇතුලත්කරන්න",
    //"Please Enter Name and Designation of the Person Involved",
    electionReport_step2_publicAuthorityDesignationFieldPlaceholder: "සිද්ධියට සම්බන්ධ පුද්ගලයාගේ නම සහ තනතුර",
    //"Name and Designation of person involved",
    electionReport_step2_publicAuthorityDesignationFieldError: "සිද්ධියට සම්බන්ධ පුද්ගලයාගේ නම සහ තනතුර අත්‍යවශ්‍යයි!",
    //"Name and Designation field is required!",

    electionReport_step2_incidentTypeFieldTitle: "කරුණාකර වාර්තා වූ සිද්ධිය තෝරන්න", //"Please Select Incident Status",
    electionReport_step2_incidentTypeFieldPlaceholder: "වාර්තා වූ සිද්ධිය", //"Select Incident Status",
    electionReport_step2_incidentTypeFieldError: "වාර්තා වූ සිද්ධිය අත්‍යවශ්‍යයි!", //"Incident Type field is required!",

    electionReport_step2_districtFieldTitle: "කරුණාකර දිස්ත්‍රික්කය තෝරන්න", //"Please Select District",
    electionReport_step2_districtFieldPlaceholder: "දිස්ත්‍රික්කය", //"Select District",
    electionReport_step2_districtFieldError: "දිස්ත්‍රික්කය අත්‍යවශ්‍යයි!", //"District field is required!",

    electionReport_step2_divisionalSecretariatFieldTitle: "කරුණාකර ප්‍රාදේශිය ලේකම් කොට්ඨාශය තෝරන්න",
    //"Please select Divisional Secretariat",
    electionReport_step2_divisionalSecretariatFieldPlaceholder: "ප්‍රාදේශිය ලේකම් කොට්ඨාශය",
    //"Select Divisional Secretariats",
    electionReport_step2_divisionalSecretariatFieldError: "ප්‍රාදේශිය ලේකම් කොට්ඨාශය අත්‍යවශ්‍යයි!",
    //"Divisional Secretariats field is required!",

    electionReport_step2_dateFieldTitle: "කරුණාකර වාර්තා වූ සිද්ධිය සිදුවූ දිනය තෝරන්න", //"Please Select Date of Incident",
    electionReport_step2_DateFieldError: "වාර්තා වූ සිද්ධිය සිදුවූ දිනය අත්‍යවශ්‍යයි!", //"Date field is required!",

    electionReport_step2_timeFieldTitle: "කරුණාකර වාර්තා වූ සිද්ධිය සිදුවූ වේලාව තෝරන්න", //"Please Select Time of Incident",
    electionReport_step2_TimeFieldError: "වාර්තා වූ සිද්ධිය සිදුවූ වේලාව අත්‍යවශ්‍යයි!", //"Time field is required!",

    electionReport_step2_LocationMapField: "ස්වයංක්‍රීයව තෝරා ගත් ස්ථානය වැරදි නම් හෝ සිද්ධිය සිදු වූ ස්ථානය නිශ්චිතවම ඔබ දන්නේ නම් කරුණාකර පහත සිතියමේ එය තෝරන්න ",
    //"If the automatically selected location is incorrect or if you know the exact location of the incident, please select it on the map below.",

    //buttons
    electionReport_step2_backButton: "ආපසු", //"Back",
    electionReport_step2_nextButton: "ඉදිරියට", //"Next",

    //stepper step 3 - form
    electionReport_step3_Title: "වැඩිදුර මූලික තොරතුරු", //"More Specific Information",

    electionReport_step3_noteText: "Apesalli.lk නිරීක්ෂණය කරන්නේ මැතිවරණ වලදී පොදු දේපළ/සම්පත් අනිසි ලෙස පරිහරණය කිරීම/ අවභාවිතය පමණි ",
    //"Apesalli.lk only monitors misuse of public property/resources during elections",

    //form
    electionReport_step3_misusedFieldTitle: "අවභාවිත කෙරෙන්නේ කුමක්ද? පහත දැක්වෙන ලැයිස්තුවෙන් එකක් හෝ කිහිපයක් තෝරාගත හැකිය.",
    //"What is being misused? Select one or more from below options.",

    //misused types
    lan_election_misusedTypes: [
        {
            key: 1,
            label: "මැතිවරණ ව්‍යාපාරයේ අරමුණු උදෙසා රජයේ වාහන භාවිත කිරීම",
            //"Use of State Vehicles for Election Campaign Purposes ",
            value: "Use of State Vehicles for Election Campaign Purposes ",
        },
        {
            key: 2,
            label: "මැතිවරණ ව්‍යාපාරයේ අරමුණු සඳහා රජයේ ගොඩනැගිල්ලක් සහ එහි පරිශ්‍රය/ඉඩම් භාවිත කිරීම ",
            //"Use of State Building & Premises/ Lands for Election Campaign Purposes ",
            value: "Use of State Building & Premises/ Lands for Election Campaign Purposes ",
        },
        {
            key: 3,
            label: "මැතිවරණය ඉලක්කකොට රාජ්‍ය නිලධාරීන් සඳහා පත්කිරීම්, මාරුකිරීම් සහ උසස්වීම් ලබා දීම",
            //"Appointments, Transfers & Promotions for State Officials targeting Election ",
            value: "Appointments, Transfers & Promotions for State Officials targeting Election ",
        },
        {
            key: 4,
            label: "රාජ්‍ය අනුග්‍රහය යටතේ කෙරෙන සංවර්ධන වැඩකටයුතු අවභාවිත කිරීම",
            //"Misusing State sponsored Development Activities ",
            value: "Misusing State sponsored Development Activities ",
        },
        {
            key: 5,
            label: "රාජ්‍ය නිලධාරීන් දේශපාලන පක්‍ෂවලට පක්ෂග්‍රාහී අකාරයෙන් සහ නිලයට අදාළ රාජකාරි උල්ලංඝනය කරමින් කටයුතු කිරීම",
            //"State Officers acting in favour of Political Parties & in Breach of Official Duties ",
            value: "State Officers acting in favour of Political Parties & in Breach of Official Duties ",
        },
        {
            key: 6,
            label: "දේශපාලන අරමුණු සහිතව දිරිදීමනා/උපකරණ ලබාදීම",
            //"Giving Incentives/Equipment with Political Objectives ",
            value: "Giving Incentives/Equipment with Political Objectives ",
        },
        {
            key: 7,
            label: "මැතිවරණ ව්‍යාපාර සඳහා රාජ්‍ය නිලධාරීන් සහ රජයේ ආරක්ෂක අංශ වල සම්පත් භාවිත කිරීම",
            //"Use of State Officials & Security Resources for Election Campaign During the Period of an Election State Officers using Social Media for the Promotion of or in Prejudice to Any Party, Group or Candidate ",
            value: "Use of State Officials & Security Resources for Election Campaign During the Period of an Election State Officers using Social Media for the Promotion of or in Prejudice to Any Party, Group or Candidate ",
        },
        {
            key: 8,
            label: "මැතිවරණ කාලසීමාව ඇතුළත රාජ්‍ය නිලධාරීන් යම් පක්ෂයක්, කණ්ඩායමක් හෝ අපේක්ෂකයෙක් ප්‍රවර්ධනය කිරීම සඳහා හෝ පක්ෂග්‍රාහි අයුරින් සමාජ මාධ්‍ය භාවිත කිරීම",
            //"During the Period of an Election State Officers using Social Media for the Promotion of or in Prejudice to Any Party, Group or Candidate ",
            value: "During the Period of an Election State Officers using Social Media for the Promotion of or in Prejudice to Any Party, Group or Candidate ",
        },
        {
            key: 9,
            label: "රජයේ අනුග්‍රහයෙන් ක්‍රියාත්මකවන ජීවනාධාර ප්‍රතිපාදන සහ දීමනාවලට බලපෑම් සිදුකිරීම",
            //"Manipulation of State sponsored Livelihood Grants & Allowances for Election Purposes ",
            value: "Manipulation of State sponsored Livelihood Grants & Allowances for Election Purposes ",
        },
        {
            key: 10,
            label: "රාජ්‍ය මාධ්‍ය ආයතනවලට අයත් උපකරණ සහ පහසුකම් ගෙවීමක් නොකොට භාවිත කිරීම",
            //"Using Equipment and Facilities of State Media Institutions Without Paying ",
            value: "Using Equipment and Facilities of State Media Institutions Without Paying ",
        },
        {
            key: 11,
            label: "විවෘත කිරීමේ උත්සව/රජයේ වියදමින් කෙරෙන උත්සවවලට සහභාගි වීම",
            //"Participating in Opening Ceremonies/ Government Funded Functions ",
            value: "Participating in Opening Ceremonies/ Government Funded Functions ",
        },
        {
            key: 12,
            label: "රාජ්‍ය සම්පත් භාවිත කරමින් කෙරෙන වෙනත් මැතිවරණ ව්‍යාපාර",
            //"Other Illegal Election Campaigns Using State Resources ",
            value: "Other Illegal Election Campaigns Using State Resources ",
        },
    ],

    //misused nature types
    lng_misused_natureTypes: [
        {
            key: "misused_description_types 1",
            label: "පෝස්ටර් ඇලවීම සඳහා/දේශපාලන රැලි සහ රැස්වීම් සංවිධානය කිරීම/ඡන්දදායකයන් ප්‍රවාහනය කිරීම සහ මැතිවරණ සම්බන්ධ වෙනත් කාර්යයන් සඳහා රජයේ වාහන භාවිත කිරීම",
            //"Use of State Vehicles to put up posters/ organize political rallies and meetings/ transport voters and similar election related activities",
            value: "Use of State Vehicles to put up posters/ organize political rallies and meetings/ transport voters and similar election related activities",
        },
        {
            key: "misused_description_types 2",
            label: "නියමිත ගෙවීම් නොකර රජයේ ගොඩනැගිලි, පරිශ්‍රයන්, හෝ ඉඩම් දේශපාලන රැලි සහ රැස්වීම් සඳහා/මැතිවරණ අපේක්ෂකයන්ගේ කාර්යාල පවත්වාගෙනයාම සඳහා සහ කටවුට්/පෝස්ටර් ප්‍රදර්ශනය කිරීම සඳහා භාවිත කිරීම",
            //"Use of State buildings, premises or lands for election rallies/meetings, to maintain offices for election candidates and to display posters/cutouts without making the necessary payments ",
            value: "Use of State buildings, premises or lands for election rallies/meetings, to maintain offices for election candidates and to display posters/cutouts without making the necessary payments ",
        },
        {
            key: "misused_description_types 3",
            label: "ක්‍රීඩා උපකරණ, කෘෂිකාර්මික උපකරණ මිලදී ගැනීම හා බෙදාහැරීම සහ ඊට සමාන සුභසාධන කාර්යයන් සඳහා රජයේ මුදල් භාවිත කිරීම",
            //"Using State Funds to purchase and distribute sports equipment, agricultural equipment, and similar welfare aid during election times.",
            value: "Using State Funds to purchase and distribute sports equipment, agricultural equipment, and similar welfare aid during election times.",
        }
    ],

    //form fields
    electionReport_step3_natureOfMisuseFieldTitle: "කරුණාකාර, අවභාවිත කෙරෙන ආකාරය විස්තර කරන්න",
    //"Describe the misuse",
    electionReport_step3_natureOfMisuseFieldPlaceholder: "කරුණාකාර, අවභාවිත කෙරෙන ආකාරය විස්තර කරන්න",
    //"Please Describe Nature of Misuse",
    electionReport_step3_natureOfMisuseFieldError: "අවභාවිත කෙරෙන්නේ කුමක්ද? එය අත්‍යවශ්‍යයි!",
    //"Nature of Misuse field is required",

    electionReport_step3_politicalPartyFieldTitle: "දේශපාලන පක්ෂයක් සම්බන්ධයිද?", // "Details of the Political Party Involved:",
    electionReport_step3_politicalPartyFieldPlaceholder: "දේශපාලන පක්ෂය", //"Political Party Involved",

    //upload
    electionReport_step3_uploadButtonTitle1: "පින්තූර සාක්‍ෂි/ඇමුණුම්", //"Upload Images",
    electionReport_step3_uploadButtonTitle2: "විඩියෝ සාක්‍ෂි/ඇමුණුම්", //"Upload Videos",

    electionReport_step3_trashButtonTooltip: "ඉවත්කරන්න", //"Remove",

    //buttons
    electionReport_step3_finishButton: "සනාථ කරන්න", //"Finish",

    //dialogBox
    electionReport_step3_DialogBoxTitle1: "දූෂණයට එරෙහිව නැගීසිටියාට ස්තුතියි !", //"Thankyou for standing against corruption !",
    electionReport_step3_DialogBoxTitle2: "ඔබගේ යොමු අංකය ", //"Your Reference Number is ",
    electionReport_step3_DialogBoxDescriptionP1: "ඔබගේ වාර්තාව සාර්ථකව යොමුකරන ලදී",//"Your Report Submitted Successfully!.",

    electionReport_step3_DialogBoxDescriptionP2: "ඔබ තවත් ආධාරක ලේඛන හෝ සාක්‍ෂි යොමුකිරීමට අදහස් කරන්නේ නම්, කරුණාකර 0112865777 අංකයට ලේඛන නිර්නාමිකව ෆැක්ස් කරන්න.",
    //"If you wish to submit more supporting documents or evidence, please Fax the documents anonymously to 0112865777.",

    electionReport_step3_DialogBoxButton: "හරි", //"Ok",

    //divisional secretariats

    lng_report_divisional_secretariats: [

        {
            key: 1,
            district: 'Kandy',
            divisional_secretariats: [
                { key: 1, value: 'Akurana', label: 'අකුරණ', },
                { key: 2, value: 'Delthota', label: 'දෙල්තොට', },
                { key: 3, value: 'Doluwa', label: 'දොලුව', },
                { key: 4, value: 'Gagawata Korale', label: 'ගඟවටකෝරලේ', },
                { key: 5, value: 'Ganga Ihala Korale', label: 'ගඟඉහළකෝරලේ', },
                { key: 6, value: 'Harispattuwa', label: 'හාරිස්පත්තුව', },
                { key: 7, value: 'Hatharaliyadda', label: 'හතරලියද්ද', },
                { key: 8, value: 'Kundasale', label: 'කුන්ඩසාලේ', },
                { key: 9, value: 'Medadumbara', label: 'මැදදුම්බර', },
                { key: 10, value: 'Minipe', label: 'මිනිපේ', },
                { key: 11, value: 'Panvila', label: 'පන්විල', },
                { key: 12, value: 'Pasbage Korale', label: 'පස්බාගේකෝරලේ', },
                { key: 13, value: 'Pathadumbara', label: 'පාතදුම්බර', },
                { key: 14, value: 'Pathahewaheta', label: 'පාතහේවාහැට', },
                { key: 15, value: 'Poojapitiya', label: 'පූජාපිටිය', },
                { key: 16, value: 'Thumpane', label: 'තුම්පනේ', },
                { key: 17, value: 'Udadumbara', label: 'උඩදුම්බර', },
                { key: 18, value: 'Udapalatha', label: 'උඩපළාත', },
                { key: 19, value: 'Udunuwara', label: 'උඩුනුවර', },
                { key: 20, value: 'Yatinuwara', label: 'යටිනුවර', },
            ],

        },
        {
            key: 2,
            district: 'Matale',

            divisional_secretariats: [
                { key: 1, value: 'Ambanganga Korale', label: 'අඹන්ගඟ කෝරලේ', },
                { key: 2, value: 'Dambulla', label: 'දඹුල්ල', },
                { key: 3, value: 'Galewela', label: 'ගලේවෙල', },
                { key: 4, value: 'Laggala-Pallegama', label: 'ලග්ගල පල්ලේගම', },
                { key: 5, value: 'Matale', label: 'මාතලේ', },
                { key: 6, value: 'Naula', label: 'නාඋල', },
                { key: 7, value: 'Pallepola', label: 'පල්ලේපොල', },
                { key: 8, value: 'Rattota', label: 'රත්තොට', },
                { key: 9, value: 'Ukuwela', label: 'උකුවෙල', },
                { key: 10, value: 'Wilgamuwa', label: 'විල්ගමුව', },
                { key: 11, value: 'Yatawatta', label: 'යටවත්ත', },
            ],

        },
        {
            key: 3,
            district: 'Nuwara Eliya',

            divisional_secretariats: [
                { key: 1, value: 'Ambagamuwa', label: 'අඹගමුව', },
                { key: 2, value: 'Hanguranketha', label: 'හගුරන්කේත', },
                { key: 3, value: 'Kothmale', label: 'කොත්මලේ', },
                { key: 4, value: 'Nuwara Eliya', label: 'නුවර එළිය', },
                { key: 5, value: 'Walapane', label: 'වලපනේ', },
            ],

        },
        {
            key: 4,
            district: 'Ampara',

            divisional_secretariats: [
                { key: 1, value: 'Addalachchenai', label: 'අඩ්ඩාලච්චේන', },
                { key: 2, value: 'Akkaraipattu', label: 'අක්කරපත්තුව', },
                { key: 3, value: 'Alayadiwembu', label: 'අලයාඩිවෙම්බු', },
                { key: 4, value: 'Ampara', label: 'අම්පාර', },
                { key: 5, value: 'Damana', label: 'දමන', },
                { key: 6, value: 'Dehiattakandiya', label: 'දෙහිඅත්තකණ්ඩිය', },
                { key: 7, value: 'Eragama', label: 'ඉරක්කාමම්', },
                { key: 8, value: 'Kalmunai Muslim', label: 'කල්මුනේ', },
                { key: 9, value: 'Kalmunai Tamil', label: 'කල්මුනේ දෙමළ', },
                { key: 10, value: 'Karaitivu', label: 'කරෙයිතිවු', },
                { key: 11, value: 'Lahugala', label: 'ලාහුගල', },
                { key: 12, value: 'Mahaoya', label: 'මහඔය', },
                { key: 13, value: 'Navithanveli', label: 'නවිදන්වැලි', },
                { key: 14, value: 'Ninthavur', label: 'නීන්දවුර්', },
                { key: 15, value: 'Padiyathalawa', label: 'පදියතලාව', },
                { key: 16, value: 'Pothuvil', label: 'පොතුවිල්', },
                { key: 17, value: 'Sainthamarathu', label: 'සයින්දමරුතු', },
                { key: 18, value: 'Samanthurai', label: 'සම්මන්තුරේ', },
                { key: 19, value: 'Thirukkovil', label: 'තිරුක්කෝවිල්', },
                { key: 20, value: 'Uhana', label: 'උහන', },
            ],

        },
        {
            key: 5,
            district: 'Batticaloa',

            divisional_secretariats: [
                { key: 1, value: 'Eravur Pattu', label: 'එරාවූර් පත්තු', },
                { key: 2, value: 'Eravur Town', label: 'එරාවූර් නගර', },
                { key: 3, value: 'Kattankudy', label: 'කාත්තන්කුඩි', },
                { key: 4, value: 'Koralai Pattu', label: 'කෝරළේ පත්තු', },
                { key: 5, value: 'Koralai Pattu Central', label: 'කෝරළේ පත්තු මධ්‍යයම', },
                { key: 6, value: 'Koralai Pattu North', label: 'කෝරළේ පත්තු උතුර', },
                { key: 7, value: 'Koralai Pattu South', label: 'කෝරළේ පත්තු දකුණ', },
                { key: 8, value: 'Koralai Pattu West', label: 'කෝරළේ පත්තු බටහිර', },
                { key: 9, value: 'Manmunai North', label: 'මාන්මුනේ උතුර', },
                { key: 10, value: 'Manmunai Pattu', label: 'මාන්මුනේ පත්තු', },
                { key: 11, value: 'Manmunai S. and Eruvil Pattu', label: 'මාන්මුනේ දකුණ සහ එරුවිල් පත්තු', },
                { key: 12, value: 'Manmunai South West', label: 'මාන්මුනේ නිරිත', },
                { key: 13, value: 'Manmunai West', label: 'මාන්මුනේ බටහිර', },
                { key: 14, value: 'Porativu Pattu', label: 'පොරතිවු පත්තු', },
            ],

        },
        {
            key: 6,
            district: 'Trincomalee',

            divisional_secretariats: [
                { key: 1, value: 'Gomarankadawala', label: 'ගෝමරන්කඩවල', },
                { key: 2, value: 'Kantalai', label: 'කන්තලේ', },
                { key: 3, value: 'Kinniya', label: 'කින්නියා', },
                { key: 4, value: 'Kuchchaveli', label: 'කුච්චවේලි', },
                { key: 5, value: 'Morawewa', label: 'මොරවැව', },
                { key: 6, value: 'Muttur', label: 'මුත්තූර්', },
                { key: 7, value: 'Padavi Sri Pura', label: 'පදවි ශ්‍රී පුර', },
                { key: 8, value: 'Seruvila', label: 'සේරුවිල', },
                { key: 9, value: 'Thambalagamuwa', label: 'තඹලගමුව', },
                { key: 10, value: 'Trincomalee', label: 'ත්‍රිකුණාමල', },
                { key: 11, value: 'Verugal', label: 'වෙරුගල්', },

            ],


        },
        {
            key: 7,
            district: 'Anuradhapura',

            divisional_secretariats: [
                { key: 1, value: 'Galnewa', label: 'ගල්නෑව', },
                { key: 2, value: 'Galenbindunuwewa', label: 'ගලෙන්බිදුනුවැව', },
                { key: 3, value: 'Horowpothana', label: 'හොරොව්පොතාන', },
                { key: 4, value: 'Ipalogama', label: 'ඉපලෝගම', },
                { key: 5, value: 'Kahatagasdigiliya', label: 'කහටගස්දිගිලිය', },
                { key: 6, value: 'Kebithigollewa', label: 'කැඹිතිගොල්ලෑව', },
                { key: 7, value: 'Kekirawa', label: 'කැකිරාව', },
                { key: 8, value: 'Mahavilachchiya', label: 'මහාවිලච්චිය', },
                { key: 9, value: 'Medawachchiya', label: 'මැදවච්චිය', },
                { key: 10, value: 'Mihinthale', label: 'මිහින්තලේ', },
                { key: 11, value: 'Nachchadoowa', label: 'නච්චදූව', },
                { key: 12, value: 'Nochchiyagama', label: 'නොච්චියාගම', },
                { key: 13, value: 'Nuwaragam Palatha Central', label: 'නුවරගම් පළාත මධ්‍යම', },
                { key: 14, value: 'Nuwaragam Palatha East', label: 'නුවරගම් පළාත නැගෙනහිර', },
                { key: 15, value: 'Padaviya', label: 'පදවිය', },
                { key: 16, value: 'Palagala', label: 'පළාගල', },
                { key: 17, value: 'Palugaswewa', label: 'පලුගස්වැව', },
                { key: 18, value: 'Rajanganaya', label: 'රාජාංගනය', },
                { key: 19, value: 'Rambewa', label: 'රඹෑව', },
                { key: 20, value: 'Thalawa', label: 'තලාව', },
                { key: 21, value: 'Thambuttegama', label: 'තඹුත්තේගම', },
                { key: 22, value: 'Thirappane', label: 'තිරප්පනේ', },

            ],

        },
        {
            key: 8,
            district: 'Polonnaruwa',

            divisional_secretariats: [
                { key: 1, value: 'Dimbulagala', label: 'දිඹුලාගල', },
                { key: 2, value: 'Elahera', label: 'ඇලහැර', },
                { key: 3, value: 'Hingurakgoda', label: 'හිඟුරක්ගොඩ', },
                { key: 4, value: 'Lankapura', label: 'ලංකාපුර', },
                { key: 5, value: 'Medirigiriya', label: 'මැදිරිගිරිය', },
                { key: 6, value: 'Thamankaduwa', label: 'තමන්කඩුව', },
                { key: 7, value: 'Welikanda', label: 'වැලිකන්ද', },

            ],

        },
        {
            key: 9,
            district: 'Jaffna',

            divisional_secretariats: [
                { key: 1, value: 'Delft', label: 'ඩෙල්ෆ්', },
                { key: 2, value: 'Island North', label: 'දුපත උතුර', },
                { key: 3, value: 'Island South', label: 'දුපත දකුණ', },
                { key: 4, value: 'Jaffna', label: 'යාපනය', },
                { key: 5, value: 'Karainagar', label: 'කරෙයිනගර්', },
                { key: 6, value: 'Nallur', label: 'නල්ලූර්', },
                { key: 7, value: 'Thenmaradchi', label: 'තේන්මාරච්චි', },
                { key: 8, value: 'Vadamaradchi East', label: 'වඩමාරච්චි නැගෙනහිර', },
                { key: 9, value: 'Vadamaradchi North', label: 'වඩමාරච්චි උතුර', },
                { key: 10, value: 'Vadamaradchi South-West', label: 'වඩමාරච්චි නිරිත', },
                { key: 11, value: 'Valikamam East', label: 'වලිකාමම් නැගෙනහිර', },
                { key: 12, value: 'Valikamam North', label: 'වලිකාමම් උතුර', },
                { key: 13, value: 'Valikamam South', label: 'වලිකාමම් දකුණ', },
                { key: 14, value: 'Valikamam South-West', label: 'වලිකාමම් නිරිත', },
                { key: 15, value: 'Valikamam West', label: 'වලිකාමම් බටහිර', },

            ],


        },
        {
            key: 10,
            district: 'Kilinochchi',

            divisional_secretariats: [
                { key: 1, value: 'Kandavalai', label: 'කණ්ඩාවලෙයි', },
                { key: 2, value: 'Karachchi', label: 'කරච්චි', },
                { key: 3, value: 'Pachchilaipalli', label: 'පලෙයි', },
                { key: 4, value: 'Poonakary', label: 'පුනරීන්', },

            ],

        },
        {
            key: 11,
            district: 'Mannar',

            divisional_secretariats: [
                { key: 1, value: 'Madhu', label: 'මඩු', },
                { key: 2, value: 'Mannar', label: 'මන්නාරම', },
                { key: 3, value: 'Manthai West', label: 'මාන්තෛ බටහිර', },
                { key: 4, value: 'Musalai', label: 'මූසාලේ', },
                { key: 5, value: 'Nanaddan', label: 'නානාට්ටාන්', },

            ],

        },
        {
            key: 12,
            district: 'Mullaitivu',

            divisional_secretariats: [
                { key: 1, value: 'Manthai East', label: 'මාන්තේ නැගෙනහිර', },
                { key: 2, value: 'Maritimepattu', label: 'මුහුදුබඩපත්තුව', },
                { key: 3, value: 'Oddusuddan', label: 'ඔඩ්ඩුසුඩාන්', },
                { key: 4, value: 'Puthukudiyiruppu', label: 'පුදුකුඩිඉරිප්පු', },
                { key: 5, value: 'Thunukkai', label: 'තුනුක්‌කායි', },
                { key: 6, value: 'Welioya', label: 'තුනුක්‌කායි', },

            ],

        },
        {
            key: 13,
            district: 'Vavuniya',

            divisional_secretariats: [
                { key: 1, value: 'Vavuniya', label: 'වවුනියාව', },
                { key: 2, value: 'Vavuniya North', label: 'වවුනියාව උතුර', },
                { key: 3, value: 'Vavuniya South', label: 'වවුනියාව දකුණ', },
                { key: 4, value: 'Vengalacheddikulam', label: 'වෙන්ගලචෙඩ්ඩිකුලම', },

            ],


        },
        {
            key: 14,
            district: 'Kurunegala',

            divisional_secretariats: [
                { key: 1, value: 'Alawwa', label: 'අලව්ව', },
                { key: 2, value: 'Ambanpola', label: 'අඹන්පොළ', },
                { key: 3, value: 'Bamunakotuwa', label: 'බමුණුකොටුව', },
                { key: 4, value: 'Bingiriya', label: 'බිංගිරිය', },
                { key: 5, value: 'Ehetuwewa', label: 'ඇහැටුවැව', },
                { key: 6, value: 'Galgamuwa', label: 'ගල්ගමුව', },
                { key: 7, value: 'Ganewatta', label: 'ගනේවත්ත', },
                { key: 8, value: 'Giribawa', label: 'ගිරිබාව', },
                { key: 9, value: 'Ibbagamuwa', label: 'ඉබ්බාගමුව', },
                { key: 10, value: 'Katupotha', label: 'කටුපොත', },

                { key: 11, value: 'Kobeigane', label: 'කොබෙයිගනේ', },
                { key: 12, value: 'Kotavehera', label: 'කොටවෙහෙර', },
                { key: 13, value: 'Kuliyapitiya East', label: 'කුලියාපිටිය නැගෙනහිර', },
                { key: 14, value: 'Kuliyapitiya West', label: 'කුලියාපිටිය බටහිර', },
                { key: 15, value: 'Kurunegala', label: 'කුරුණෑගල', },
                { key: 16, value: 'Mahawa', label: 'මහව', },
                { key: 17, value: 'Mallawapitiya', label: 'මල්ලවපිටිය', },
                { key: 18, value: 'Maspotha', label: 'මාස්පොත', },
                { key: 19, value: 'Mawathagama', label: 'මාවතගම', },
                { key: 20, value: 'Narammala', label: 'නාරම්මල', },

                { key: 21, value: 'Nikaweratiya', label: 'නිකවැරටිය', },
                { key: 22, value: 'Panduwasnuwara', label: 'පඩුවස්නුවර', },
                { key: 23, value: 'Pannala', label: 'පන්නල', },
                { key: 24, value: 'Polgahawela', label: 'පොල්ගහවෙල', },
                { key: 25, value: 'Polpithigama', label: 'පොල්පිතිගම', },
                { key: 26, value: 'Rasnayakapura', label: 'රස්නායකපුර', },
                { key: 27, value: 'Rideegama', label: 'රිදිගම', },
                { key: 28, value: 'Udubaddawa', label: 'උඩුබැද්දාව', },
                { key: 29, value: 'Wariyapola', label: 'වාරියපොල', },
                { key: 30, value: 'Weerambugedara', label: 'වීරඹුගෙදර', },

            ],

        },
        {
            key: 15,
            district: 'Puttalam',

            divisional_secretariats: [
                { key: 1, value: 'Anamaduwa', label: 'ආණමඩුව', },
                { key: 2, value: 'Arachchikattuwa', label: 'ආරච්චිකට්ටුව', },
                { key: 3, value: 'Chilaw', label: 'හලාවත', },
                { key: 4, value: 'Dankotuwa', label: 'දංකොටුව', },
                { key: 5, value: 'Kalpitiya', label: 'කල්පිටිය', },
                { key: 6, value: 'Karuwalagaswewa', label: 'කරුවලගස්වැව', },
                { key: 7, value: 'Madampe', label: 'මාදම්පෙ', },
                { key: 8, value: 'Mahakumbukkadawala', label: 'මහකුඹුක්කඩවල', },
                { key: 9, value: 'Mahawewa', label: 'මහවැව', },
                { key: 10, value: 'Mundalama', label: 'මුන්දලම', },
                { key: 11, value: 'Nattandiya', label: 'නාත්තන්ඩිය', },
                { key: 12, value: 'Nawagattegama', label: 'නවගත්තේගම', },
                { key: 13, value: 'Pallama', label: 'පල්ලම', },
                { key: 14, value: 'Puttalam', label: 'පුත්තලම', },
                { key: 15, value: 'Vanathavilluwa', label: 'වනාතවිල්ලුව', },
                { key: 16, value: 'Wennappuwa', label: 'වෙන්නප්පුව', },

            ],

        },
        {
            key: 16,
            district: 'Kegalle',

            divisional_secretariats: [
                { key: 1, value: 'Aranayaka', label: 'අරණායක', },
                { key: 2, value: 'Bulathkohupitiya', label: 'බුලත්කොහුපිටිය', },
                { key: 3, value: 'Dehiovita', label: 'දෙහිඕවිට', },
                { key: 4, value: 'Deraniyagala', label: 'දැරණියගල', },
                { key: 5, value: 'Galigamuwa', label: 'ගලිගමුව', },
                { key: 6, value: 'Kegalle', label: 'කෑගල්ල', },
                { key: 7, value: 'Mawanella', label: 'මාවනැල්ල', },
                { key: 8, value: 'Rambukkana', label: 'රඹුක්කන', },
                { key: 9, value: 'Ruwanwella', label: 'රුවන්වැල්ල', },
                { key: 10, value: 'Warakapola', label: 'වරකාපොල', },
                { key: 11, value: 'Yatiyanthota', label: 'යටියන්තොට', },

            ],

        },
        {
            key: 17,
            district: 'Ratnapura',

            divisional_secretariats: [
                { key: 1, value: 'Ayagama', label: 'අයගම', },
                { key: 2, value: 'Balangoda', label: 'බලංගොඩ', },
                { key: 3, value: 'Eheliyagoda', label: 'ඇහැලියගොඩ', },
                { key: 4, value: 'Elapattha', label: 'ඇලපාත', },
                { key: 5, value: 'Embilipitiya', label: 'ඇඹිලිපිටිය', },
                { key: 6, value: 'Godakawela', label: 'ගොඩකවෙල', },

                { key: 7, value: 'Imbulpe', label: 'ඉඹුල්පේ', },
                { key: 8, value: 'Kahawatta', label: 'කහවත්ත', },
                { key: 9, value: 'Kalawana', label: 'කලවාන', },
                { key: 10, value: 'Kiriella', label: 'කිරිඇල්ල', },
                { key: 11, value: 'Kolonna', label: 'කොලොන්න', },
                { key: 12, value: 'Kuruvita', label: 'කුරුවිට', },

                { key: 13, value: 'Nivithigala', label: 'නිවිතිගල', },
                { key: 14, value: 'Opanayaka', label: 'ඕපනායක', },
                { key: 15, value: 'Pelmadulla', label: 'පැල්මඩුල්ල', },
                { key: 16, value: 'Ratnapura', label: 'රත්නපුර', },
                { key: 17, value: 'Weligepola', label: 'වැලිගෙපොල', },
                // { key: 18, value: 'Pelmadulla',  label: 'පැල්මඩුල්ල', },

            ],

        },
        {
            key: 18,
            district: 'Galle',

            divisional_secretariats: [
                { key: 1, value: 'Akmeemana', label: 'අක්මීමණ', },
                { key: 2, value: 'Ambalangoda', label: 'අම්බලන්ගොඩ', },
                { key: 3, value: 'Baddegama', label: 'බද්දේගම', },
                { key: 4, value: 'Balapitiya', label: 'බලපිටිය', },
                { key: 5, value: 'Benthota', label: 'බෙන්තොට', },
                { key: 6, value: 'Bope-Poddala', label: 'බෝපෙ-පෝද්දල', },
                { key: 7, value: 'Elpitiya', label: 'ඇල්පිටිය', },
                { key: 8, value: 'Galle', label: 'කඩවත්සතර', },
                { key: 9, value: 'Gonapinuwala', label: 'ගෝනපීනුවල', },
                { key: 10, value: 'Habaraduwa', label: 'හබරාදුව', },
                { key: 11, value: 'Hikkaduwa', label: 'හික්කඩුව', },
                { key: 12, value: 'Imaduwa', label: 'ඉමදුව', },
                { key: 13, value: 'Karandeniya', label: 'කරන්දෙනිය', },
                { key: 14, value: 'Nagoda', label: 'නාගොඩ', },
                { key: 15, value: 'Neluwa', label: 'නෙළුව', },
                { key: 16, value: 'Niyagama', label: 'නියාගම', },
                { key: 17, value: 'Thawalama', label: 'තවලම', },
                { key: 18, value: 'Welivitiya-Divithura', label: 'වැලිවිටිය-දිවිතුර', },
                { key: 19, value: 'Yakkalamulla', label: 'යක්කලමුල්ල', },

            ],
        },
        {
            key: 19,
            district: 'Hambantota',

            divisional_secretariats: [
                { key: 1, value: 'Ambalantota', label: 'අම්බලන්තොට', },
                { key: 2, value: 'Angunakolapelessa', label: 'අඟුණුකොළපැලැස්ස', },
                { key: 3, value: 'Beliatta', label: 'බෙලිඅත්ත', },
                { key: 4, value: 'Hambantota', label: 'හම්බන්තොට', },
                { key: 5, value: 'Katuwana', label: 'කටුවන', },
                { key: 6, value: 'Lunugamvehera', label: 'ලුණුගම්වෙහෙර', },
                { key: 7, value: 'Okewela', label: 'ඕකේවෙල', },
                { key: 8, value: 'Sooriyawewa', label: 'සූරියවැව', },
                { key: 9, value: 'Tangalle', label: 'තංගල්ල', },
                { key: 10, value: 'Thissamaharama', label: 'තිස්සමහාරාම', },
                { key: 11, value: 'Walasmulla', label: 'වලස්මුල්ල', },
                { key: 12, value: 'Weeraketiya', label: 'වීරකැටිය', },
            ],

        },
        {
            key: 20,
            district: 'Matara',

            divisional_secretariats: [
                { key: 1, value: 'Akuressa', label: 'අකුරැස්ස', },
                { key: 2, value: 'Athuraliya', label: 'අතුරලිය', },
                { key: 3, value: 'Devinuwara', label: 'දෙවිනුවර', },
                { key: 4, value: 'Dickwella', label: 'දික්වැල්ල', },
                { key: 5, value: 'Hakmana', label: 'හක්මන', },
                { key: 6, value: 'Kamburupitiya', label: 'කඹුරුපිටිය', },
                { key: 7, value: 'Kirinda Puhulwella', label: 'කිරින්ද පුහුල්වැල්ල', },
                { key: 8, value: 'Kotapola', label: 'කොටපොල', },
                { key: 9, value: 'Malimbada', label: 'මාලිම්බඩ', },
                { key: 10, value: 'Matara', label: 'මාතර', },
                { key: 11, value: 'Mulatiyana', label: 'මුලටියන', },
                { key: 12, value: 'Pasgoda', label: 'පස්ගොඩ', },
                { key: 13, value: 'Pitabeddara', label: 'පිටබැද්දර', },
                { key: 14, value: 'Thihagoda', label: 'තිහගොඩ', },
                { key: 15, value: 'Weligama', label: 'වැලිගම', },
                { key: 16, value: 'Welipitiya', label: 'වැලිපිටිය', },
            ],

        },
        {
            key: 21,
            district: 'Badulla',

            divisional_secretariats: [
                { key: 1, value: 'Badulla', label: 'බදුල්ල', },
                { key: 2, value: 'Bandarawela', label: 'බණ්ඩාරවෙල', },
                { key: 3, value: 'Ella', label: 'ඇල්ල', },
                { key: 4, value: 'Haldummulla', label: 'හල්දුම්මුල්ල', },
                { key: 5, value: 'Hali-Ela', label: 'හාලිඇල', },
                { key: 6, value: 'Haputale', label: 'හපුතලේ', },
                { key: 7, value: 'Kandaketiya', label: 'කන්දෙකැටිය', },
                { key: 8, value: 'Lunugala', label: 'ලුණුගල', },
                { key: 9, value: 'Mahiyanganaya', label: 'මහියංගනය', },
                { key: 10, value: 'Meegahakivula', label: 'මීගහකිවුල', },
                { key: 11, value: 'Passara', label: 'පස්සර', },
                { key: 12, value: 'Rideemaliyadda', label: 'රිදීමාලියැද්ද', },
                { key: 13, value: 'Soranathota', label: 'සොරණාතොට', },
                { key: 14, value: 'Uva-Paranagama', label: 'ඌවපරණගම', },
                { key: 15, value: 'Welimada', label: 'වැලිමඩ', },

            ],

        },
        {
            key: 22,
            district: 'Monaragala',

            divisional_secretariats: [
                { key: 1, value: 'Badalkumbura', label: 'බඩල්කුඹුර', },
                { key: 2, value: 'Bibile', label: 'බිබිල', },
                { key: 3, value: 'Buttala', label: 'බුත්තල', },
                { key: 4, value: 'Katharagama', label: 'කතරගම', },
                { key: 5, value: 'Madulla', label: 'මඩුල්ල-දඹගල්ල', },
                { key: 6, value: 'Medagama', label: 'මැදගම', },
                { key: 7, value: 'Moneragala', label: 'මොණරාගල', },
                { key: 8, value: 'Sevanagala', label: 'සෙවනගල', },
                { key: 9, value: 'Siyambalanduwa', label: 'සියඹලාණ්ඩුව', },
                { key: 10, value: 'Thanamalvila', label: 'තණමල්විල', },
                { key: 11, value: 'Wellawaya', label: 'වැල්ලවාය', },
            ],

        },
        {
            key: 23,
            district: 'Colombo',

            divisional_secretariats: [
                { key: 1, value: 'Colombo', label: 'කොළඹ', },
                { key: 2, value: 'Dehiwala', label: 'දෙහිවල', },
                { key: 3, value: 'Homagama', label: 'හෝමාගම', },
                { key: 4, value: 'Kaduwela', label: 'කඩුවෙල', },
                { key: 5, value: 'Kesbewa', label: 'කැස්බෑව', },
                { key: 6, value: 'Kolonnawa', label: 'කොලොන්නාව', },
                { key: 7, value: 'Kotte', label: 'කෝට්ටේ', },
                { key: 8, value: 'Maharagama', label: 'මහරගම', },
                { key: 9, value: 'Moratuwa', label: 'මොරටුව', },
                { key: 10, value: 'Padukka', label: 'පාදුක්ක', },
                { key: 11, value: 'Ratmalana', label: 'රත්මලාන', },
                { key: 12, value: 'Seethawaka', label: 'සීතාවක', },
                { key: 13, value: 'Thimbirigasyaya', label: 'තිඹිරිගස්යාය', },
            ],

        },
        {
            key: 24,
            district: 'Gampaha',

            divisional_secretariats: [
                { key: 1, value: 'Attanagalla', label: 'අත්තනගල්ල', },
                { key: 2, value: 'Biyagama', label: 'බියගම', },
                { key: 3, value: 'Divulapitiya', label: 'දිවුලපිටිය', },
                { key: 3, value: 'Dompe', label: 'දොම්පෙ', },
                { key: 3, value: 'Gampaha', label: 'ගම්පහ', },
                { key: 3, value: 'Ja-Ela', label: 'ජා-ඇල', },
                { key: 3, value: 'Katana', label: 'කටාන', },
                { key: 3, value: 'Kelaniya', label: 'කැළණිය', },
                { key: 3, value: 'Mahara', label: 'මහර', },
                { key: 3, value: 'Minuwangoda', label: 'මිනුවන්ගොඩ', },
                { key: 3, value: 'Mirigama', label: 'මීරිගම', },
                { key: 3, value: 'Negombo', label: 'මීගමුව', },
                { key: 3, value: 'Wattala', label: 'වත්තල', },
            ],

        },
        {
            key: 25,
            district: 'Kalutara',

            divisional_secretariats: [
                { key: 1, value: 'Agalawatta', label: 'අගලවත්ත', },
                { key: 2, value: 'Bandaragama', label: 'බණ්ඩාරගම', },
                { key: 3, value: 'Beruwala', label: 'බේරුවල', },
                { key: 4, value: 'Bulathsinhala', label: 'බුලත්සිංහල', },
                { key: 5, value: 'Dodangoda', label: 'දොඩංගොඩ', },
                { key: 6, value: 'Horana', label: 'හොරණ', },
                { key: 7, value: 'Ingiriya', label: 'ඉංගිරිය', },
                { key: 8, value: 'Kalutara', label: 'කළුතර', },
                { key: 9, value: 'Madurawela', label: 'මදුරාවෙල', },
                { key: 10, value: 'Mathugama', label: 'මතුගම', },
                { key: 11, value: 'Millaniya', label: 'මිල්ලනිය', },
                { key: 12, value: 'Palindanuwara', label: 'පාලින්දනුවර', },
                { key: 13, value: 'Panadura', label: 'පානදුර', },
                { key: 14, value: 'Walallavita', label: 'වලල්ලාවිට', },

            ],

        },

    ],

    //Reports Page - Home
    reportsPage_Title: 'වාර්තා',
    reportsPage_Button: 'වැඩිදුර කියවන්න...',

    //Stories Page - Home
    storiesPage_Title: 'කතා',
    storiesPage_Button: 'වැඩිදුර කියවන්න...',

    storiesPage_authorityName: 'සිද්ධියට සම්බන්ධ ආයතනය',
    storiesPage_personDesignation: 'සිද්ධියට සම්බන්ධ පුද්ගලයාගේ නම සහ තනතුර',
    storiesPage_district: 'දිස්ත්‍රික්කය',
    storiesPage_divisionalSecratarient: 'ප්‍රාදේශිය ලේකම් කොට්ඨාශය',
    storiesPage_IncidentDate: 'සිද්ධිය සිදුවූ දිනය',
    storiesPage_IncidentTime: 'සිද්ධිය සිදුවූ වේලාව',
    storiesPage_story: 'කතාව - ',

    //Incident Single View Page - Home
    inidentSigleView_Main_TitleFirst: 'සිද්ධිය',
    inidentSigleView_Main_Title1: 'කතාව',
    inidentSigleView_Main_Title2: 'මැතිවරණ නීති උල්ලංඝනය කිරීම',
    inidentSigleView_published_date_Title: 'පළකරන ලද දිනය',

    inidentSigleView_BriberyAndSexualFavours_youAre: "ඔබ, වාර්තා කරන පුද්ගලයා", //"You Involved As",
    inidentSigleView_Bribery_form: "අල්ලස කුමන ස්වභාවයේ එකක්ද?", //"Bribe From",
    inidentSigleView_Bribery_value: "මූල්‍යමය අගය", //"Monetary Value",

    inidentSigleView_misuseFunds: "දේපළ වර්ගය", //"Type of Property",

    inidentSigleView_misusePosition: "චූදිතයා ලබාගෙන හෝ ලබාදී ඇත්තේ කුමන ප්‍රතිලාභයක්ද?", //"Benefit",

    inidentSigleView_conflict_field1: "පෞද්ගලික අභිලාශ අභිලාශ පවතීද?", //"Private Interest",
    inidentSigleView_conflict_field2: "අභිලාශයේ ස්වභාවය හෙලිදරව් කළේද?", //"Nature Of Interest",
    inidentSigleView_conflict_field3: "පෞද්ගලික අභිලාශ සම්බන්ධ වූ තීරණයක් ගැනීමට සහභාගි වූයේද?", //"Disclose Interest",
    inidentSigleView_conflict_field4: "පෞද්ගලික අභිලාශ සම්බන්ධ වූ තීරණයක් ගැනීමට සහභාගි වූයේද?", //"Involved",
    inidentSigleView_conflict_field5: "එම තීරණය ගැනීමට අදාළ ක්‍රියාවලියට සම්බන්ධ වීමට එම පුද්ගලයාට බලය ලැබී තිබුණිද?", //"Authorized Participate",

    inidentSigleView_procurement_field: "රාජ්‍ය ප්‍රසම්පාදන අක්‍රමිකතාවක්ද?", //"Type of Procurement",

    inidentSigleView_election_field1: "අවභාවිත කෙරෙන්නේ කුමක්ද?", //"Nature of Misuse",
    inidentSigleView_election_field2: "දේශපාලන පක්ෂයක් සම්බන්ධයිද?", //"Political Party",
    inidentSigleView_election_field3: "අවභාවිත කෙරෙන ආකාරය", //"What Is Being Misused?",

    inidentSigleView_otherDetails: "අනෙකුත් තොරතුරු", //"Other Details",


    //other pages - search bar
    searchbar_placeholder: "යොමු අංකයෙන් සොයන්න",
    incidents_latestStories: "යාවත්කාලීන කරන ලද කතා",

    //News Page - Home
    newsPage_Title: "පුවත්", //'News',
    newsPage_Button: "වැඩිදුර කියවන්න...", //'Read More...',
    newsPage_latestText: "උණුසුම් පුවත්",

    //News Single View Page - Home
    newsPage_published_Txt: 'පළකරන ලද',
    newsPage_published_date_Title: 'පළකරන ලද දිනය', //'Published on',
    newsPage_links_title: "වැඩිදුර කියවන්න...", //'Click to Read More...',

    //chart
    statisticsPage_button1: "සියලු සිදුවීම්", //"Total Incidents",
    statisticsPage_button2: "ගෙන ඇති පියවර", //"Action Taken",
    statisticsPage_button3: "සියලු කතා",//"Total Stories",
    statisticsPage_button4: "මැතිවරණ උල්ලංඝණය කිරීම්", //"Election Violations",

    statisticsPage_Chart_hoverText1: "සිදුවීම්",

    statisticsPage_Chart_Tytpe1: "රේඛා ප්‍රස්තාර", //"Line View",
    statisticsPage_Chart_Tytpe2: "තිර ප්‍රස්තාර", //"Bar View",
    statisticsPage_Chart_Tytpe3: "Tiled View",

    statisticsPage_Chart_SaveImage: "බාගතකරගන්න", //"Save Image",
    incidentsChart_noOfIncidents: "සිදුවීම්",

    //Age wise Chart
    statisticsPage_AgeChart_Title: "වයස අනුව සිදුවීම්",
    statisticsPage_AgeChart_XAxis: "වයස", //"Age",

    //All incidents by category Chart
    statisticsPage_CategoryChart_Title: "වාර්තා වූ සිදුවීම් ඒවායේ ස්වභාවය අනුව", //"All Incidents by Category",
    statisticsPage_CategoryChartChart_hoverText: "සිදුවීම් වර්ගය",
    incidentsChart_title: "වාර්තා වූ සිදුවීම් ඒවායේ ස්වභාවය අනුව", //"All Incidents by Category",

    incidentsChart_noOfIncidents: "සිදුවීම්",

    incidentsChart_bribery: "අල්ලස්", //"Bribery",
    incidentsChart_sexualFavours: "ලිංගික අල්ලස්", //"Sexual Favours",
    incidentsChart_election: "මැතිවරණ නීති උල්ලංඝනය කිරීම්", //"Election",
    incidentsChart_misuseOfProperty: "මහජන මුදල් හෝ දේපළ අවභාවිතය",//"Misuse of Public Funds or Property",
    incidentsChart_misuseOfPosition: "රාජ්‍ය තනතුරු අවභාවිතය", //"Misuse of Public Position",
    incidentsChart_conflict: "බැඳියා පිළිගැටුම", //"Conflict of Interest",
    incidentsChart_procurement: "රාජ්‍ය ප්‍රසම්පාදන අක්‍රමිකතා", //"Public Procurement Irregularities",
    incidentsChart_other: "වෙනත්", //"Other",
    incidentsChart_askToContact: "සම්බන්ධ කරගන්නා ලෙස ඉල්ලන්න ලද",

    //year wise chart
    statisticsPage_YearChart_Title: "වර්ෂ අනුව සිදුවීම්", //"Incidents Year Wise",
    statisticsPage_YearChart_XAxis: "වර්ෂය",

    //year Gender Wise chart
    statisticsPage_GenderChart_Title: "ස්ත්‍රී/පුරුෂභාවය අනුව සිදුවීම්",
    statisticsPage_GenderChart_XAxis: "ස්ත්‍රී/පුරුෂභාවය",


    //Org Wise wise chart
    statisticsPage_OrgChart_Title: "සියලු සිදුවීම් සංවිධාන අනුව",
    statisticsPage_OrgChartChart_hoverText: "සිදුවීම් වර්ගය",

    //District Wise wise chart
    statisticsPage_DistrictChart_Title: "සියලු සිදුවීම් දිස්ත්‍රික්ක අනුව",
    designation_of_authority_validation_msg: "කරුණාකර අකුරු 400ට අඩු අගයක් ඇතුළත් කරන්න",
    nature_of_misuse_length_validation_msg: "කරුණාකර අකුරු 800ට අඩු අගයක් ඇතුළත් කරන්න"
};
